import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, createVNode as _createVNode, withModifiers as _withModifiers, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 min-h-screen" }
const _hoisted_2 = { class: "p-4 bg-white shadow-sm" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "flex flex-wrap gap-3 items-end pb-1" }
const _hoisted_5 = { class: "flex flex-col shrink-0" }
const _hoisted_6 = { class: "flex flex-col shrink-0" }
const _hoisted_7 = { class: "flex flex-col shrink-0" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "flex flex-col shrink-0" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "flex flex-col shrink-0" }
const _hoisted_13 = { class: "flex flex-col shrink-0" }
const _hoisted_14 = { class: "flex flex-col shrink-0" }
const _hoisted_15 = { class: "flex flex-col shrink-0" }
const _hoisted_16 = { class: "flex flex-col shrink-0" }
const _hoisted_17 = { class: "flex gap-1" }
const _hoisted_18 = {
  key: 0,
  class: "text-center py-12"
}
const _hoisted_19 = {
  key: 1,
  class: "p-4"
}
const _hoisted_20 = { class: "max-w-7xl mx-auto" }
const _hoisted_21 = {
  key: 0,
  class: "bg-white rounded-lg shadow-sm overflow-hidden"
}
const _hoisted_22 = {
  class: "bg-gray-50 px-6 py-3 border-b",
  style: {"text-align":"left"}
}
const _hoisted_23 = { class: "text-lg font-semibold text-gray-800" }
const _hoisted_24 = { class: "divide-y divide-gray-200" }
const _hoisted_25 = { class: "flex items-center justify-between" }
const _hoisted_26 = { class: "flex-1" }
const _hoisted_27 = { class: "flex flex-wrap items-center gap-4 mb-3" }
const _hoisted_28 = { class: "text-lg font-semibold text-gray-900" }
const _hoisted_29 = {
  key: 0,
  class: "px-2 py-1 rounded-full text-xs font-medium",
  style: {"background-color":"#ffedd5","color":"#c2410c"}
}
const _hoisted_30 = { class: "text-sm text-blue-600 font-medium" }
const _hoisted_31 = { class: "text-sm text-gray-600" }
const _hoisted_32 = { class: "text-sm text-gray-600" }
const _hoisted_33 = {
  key: 3,
  class: "px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-700"
}
const _hoisted_34 = { class: "flex items-center gap-6 text-sm text-gray-600 mb-3" }
const _hoisted_35 = { class: "flex items-center" }
const _hoisted_36 = { class: "flex items-center" }
const _hoisted_37 = { class: "flex items-center" }
const _hoisted_38 = {
  key: 0,
  class: "flex items-center text-orange-600 font-medium"
}
const _hoisted_39 = {
  key: 1,
  class: "flex items-center text-green-600 font-medium"
}
const _hoisted_40 = {
  key: 2,
  class: "flex items-center text-cyan-700 font-medium"
}
const _hoisted_41 = {
  class: "text-sm text-gray-600",
  style: {"text-align":"left"}
}
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 font-medium",
  style: {"text-align":"left"}
}
const _hoisted_44 = { class: "flex flex-col items-end gap-3" }
const _hoisted_45 = { class: "text-xl font-bold text-gray-900" }
const _hoisted_46 = { class: "flex flex-wrap justify-end gap-2" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  key: 3,
  class: "flex overflow-hidden rounded text-sm text-white"
}
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["disabled", "onClick"]
const _hoisted_59 = {
  key: 0,
  class: "border-t bg-gray-50 px-4 py-4 flex flex-wrap items-center justify-between gap-3"
}
const _hoisted_60 = { class: "text-sm text-gray-600" }
const _hoisted_61 = { class: "flex flex-wrap items-center justify-end gap-2" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = ["onClick"]
const _hoisted_64 = ["disabled"]
const _hoisted_65 = {
  key: 2,
  class: "text-center py-12"
}
const _hoisted_66 = {
  key: 0,
  class: "p-6"
}
const _hoisted_67 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" }
const _hoisted_68 = { class: "space-y-4" }
const _hoisted_69 = { class: "space-y-2" }
const _hoisted_70 = { class: "flex justify-between" }
const _hoisted_71 = { class: "font-medium" }
const _hoisted_72 = { class: "flex justify-between" }
const _hoisted_73 = { class: "font-medium" }
const _hoisted_74 = { class: "flex justify-between" }
const _hoisted_75 = { class: "font-medium text-blue-600" }
const _hoisted_76 = { class: "flex justify-between" }
const _hoisted_77 = { class: "font-medium" }
const _hoisted_78 = { class: "flex justify-between" }
const _hoisted_79 = { class: "font-medium" }
const _hoisted_80 = { class: "flex justify-between" }
const _hoisted_81 = { class: "font-medium" }
const _hoisted_82 = { class: "flex justify-between" }
const _hoisted_83 = {
  key: 0,
  class: "flex justify-between gap-4"
}
const _hoisted_84 = { class: "font-medium text-cyan-700 text-right break-all" }
const _hoisted_85 = {
  key: 1,
  class: "flex justify-between gap-4"
}
const _hoisted_86 = { class: "font-medium text-cyan-700 text-right break-all" }
const _hoisted_87 = {
  key: 2,
  class: "flex justify-between gap-4"
}
const _hoisted_88 = { class: "font-medium text-cyan-700 text-right" }
const _hoisted_89 = {
  key: 3,
  class: "flex justify-between"
}
const _hoisted_90 = { class: "font-medium text-green-600" }
const _hoisted_91 = { class: "flex justify-between" }
const _hoisted_92 = { class: "font-medium" }
const _hoisted_93 = {
  key: 4,
  class: "flex justify-between gap-4"
}
const _hoisted_94 = { class: "font-medium text-cyan-700 text-right" }
const _hoisted_95 = {
  key: 5,
  class: "flex justify-between"
}
const _hoisted_96 = { class: "font-medium text-red-600" }
const _hoisted_97 = { class: "flex justify-between" }
const _hoisted_98 = { class: "font-medium text-orange-600" }
const _hoisted_99 = { class: "flex justify-between" }
const _hoisted_100 = { class: "space-y-4" }
const _hoisted_101 = { class: "space-y-2" }
const _hoisted_102 = { class: "flex justify-between" }
const _hoisted_103 = { class: "font-medium" }
const _hoisted_104 = { class: "flex justify-between" }
const _hoisted_105 = { class: "font-medium" }
const _hoisted_106 = { class: "flex justify-between" }
const _hoisted_107 = { class: "font-medium" }
const _hoisted_108 = { class: "flex justify-between" }
const _hoisted_109 = { class: "font-medium text-red-600" }
const _hoisted_110 = { class: "flex justify-between text-lg font-bold border-t pt-2" }
const _hoisted_111 = { class: "text-red-600" }
const _hoisted_112 = { class: "space-y-4" }
const _hoisted_113 = { class: "border-b mb-2 flex flex-wrap gap-4" }
const _hoisted_114 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_115 = { class: "overflow-x-auto" }
const _hoisted_116 = { class: "w-full min-w-[800px] table-fixed text-sm" }
const _hoisted_117 = { class: "divide-y divide-gray-200" }
const _hoisted_118 = { class: "p-3 font-medium text-left whitespace-normal break-words" }
const _hoisted_119 = {
  key: 0,
  class: "mt-1 text-xs text-orange-700"
}
const _hoisted_120 = { class: "p-3 text-center whitespace-nowrap" }
const _hoisted_121 = {
  key: 0,
  class: "block text-xs text-gray-400"
}
const _hoisted_122 = { class: "p-3 text-center whitespace-nowrap" }
const _hoisted_123 = { class: "p-3 text-center whitespace-nowrap" }
const _hoisted_124 = { class: "p-3 text-center whitespace-nowrap" }
const _hoisted_125 = {
  key: 0,
  class: "text-blue-600"
}
const _hoisted_126 = {
  key: 1,
  class: "text-orange-600"
}
const _hoisted_127 = {
  key: 2,
  class: "text-gray-600"
}
const _hoisted_128 = { class: "p-3 text-center whitespace-nowrap" }
const _hoisted_129 = {
  key: 0,
  class: "text-green-600"
}
const _hoisted_130 = {
  key: 1,
  class: "text-green-600"
}
const _hoisted_131 = {
  key: 2,
  class: "text-green-600"
}
const _hoisted_132 = {
  key: 3,
  class: "text-green-600"
}
const _hoisted_133 = {
  key: 4,
  class: "text-gray-600"
}
const _hoisted_134 = { class: "p-3 text-right font-medium whitespace-nowrap" }
const _hoisted_135 = {
  key: 1,
  class: "space-y-2"
}
const _hoisted_136 = {
  key: 0,
  class: "overflow-x-auto pb-2"
}
const _hoisted_137 = { class: "min-w-max" }
const _hoisted_138 = { class: "text-sm table-auto" }
const _hoisted_139 = { class: "divide-y divide-gray-200" }
const _hoisted_140 = { class: "p-3 font-medium text-left" }
const _hoisted_141 = {
  key: 0,
  class: "text-xs text-gray-500 font-normal"
}
const _hoisted_142 = { class: "p-3 text-left text-gray-600 break-all" }
const _hoisted_143 = { class: "p-3 text-left text-gray-600 whitespace-nowrap" }
const _hoisted_144 = { class: "text-gray-400" }
const _hoisted_145 = { class: "p-3 text-center text-gray-600 whitespace-nowrap" }
const _hoisted_146 = { class: "p-3 text-center whitespace-nowrap" }
const _hoisted_147 = { class: "p-3 text-center whitespace-nowrap" }
const _hoisted_148 = { class: "p-3 text-center text-gray-600 whitespace-nowrap" }
const _hoisted_149 = { class: "p-3 text-center whitespace-nowrap" }
const _hoisted_150 = { class: "p-3 text-center text-gray-600 whitespace-nowrap" }
const _hoisted_151 = { class: "p-3 text-center text-gray-600 whitespace-nowrap" }
const _hoisted_152 = {
  key: 1,
  class: "text-sm text-gray-500 bg-gray-50 rounded-lg p-3"
}
const _hoisted_153 = {
  key: 2,
  class: "space-y-2"
}
const _hoisted_154 = {
  key: 0,
  class: "overflow-x-auto bg-gray-50 rounded-lg"
}
const _hoisted_155 = { class: "w-full text-sm" }
const _hoisted_156 = { class: "divide-y divide-gray-200" }
const _hoisted_157 = { class: "p-3 text-left font-medium" }
const _hoisted_158 = { class: "p-3 text-left" }
const _hoisted_159 = { class: "p-3 text-center" }
const _hoisted_160 = { class: "p-3 text-right text-red-600 font-medium" }
const _hoisted_161 = { class: "p-3 text-center" }
const _hoisted_162 = { class: "p-3 text-center" }
const _hoisted_163 = { class: "p-3 text-center whitespace-nowrap" }
const _hoisted_164 = ["disabled", "onClick"]
const _hoisted_165 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_166 = {
  key: 1,
  class: "text-sm text-gray-500 bg-gray-50 rounded-lg p-3"
}
const _hoisted_167 = {
  key: 3,
  class: "space-y-2"
}
const _hoisted_168 = { class: "overflow-x-auto" }
const _hoisted_169 = { class: "w-full text-sm" }
const _hoisted_170 = { class: "divide-y divide-gray-200" }
const _hoisted_171 = { class: "p-3 text-left font-medium" }
const _hoisted_172 = { class: "p-3 text-center text-gray-600" }
const _hoisted_173 = { class: "p-3 text-center text-red-600" }
const _hoisted_174 = { class: "p-3 text-center" }
const _hoisted_175 = { class: "p-3 text-center text-gray-600" }
const _hoisted_176 = { class: "p-3 text-left text-gray-600" }
const _hoisted_177 = { class: "flex gap-3 mt-6 pt-6 border-t" }
const _hoisted_178 = { class: "p-6" }
const _hoisted_179 = { class: "mb-4" }
const _hoisted_180 = { class: "mb-4" }
const _hoisted_181 = ["placeholder"]
const _hoisted_182 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_183 = { class: "mb-4" }
const _hoisted_184 = { class: "bg-white rounded-xl p-6 w-full max-w-md" }
const _hoisted_185 = { class: "flex justify-between items-center mb-4" }
const _hoisted_186 = ["disabled"]
const _hoisted_187 = { class: "text-gray-600 mb-4" }
const _hoisted_188 = { class: "mb-4" }
const _hoisted_189 = { class: "flex flex-wrap gap-2" }
const _hoisted_190 = ["onClick"]
const _hoisted_191 = { class: "mb-6" }
const _hoisted_192 = { class: "flex gap-3" }
const _hoisted_193 = ["disabled"]
const _hoisted_194 = ["disabled"]
const _hoisted_195 = { key: 0 }
const _hoisted_196 = { key: 1 }
const _hoisted_197 = {
  key: 6,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
}
const _hoisted_198 = { class: "bg-white rounded-xl p-6 w-96 max-w-md max-h-[90vh] overflow-y-auto" }
const _hoisted_199 = { class: "mb-4 p-3 bg-gray-50 rounded-lg" }
const _hoisted_200 = { class: "flex justify-between items-center mb-2" }
const _hoisted_201 = { class: "font-medium" }
const _hoisted_202 = { class: "flex justify-between items-center mb-2" }
const _hoisted_203 = { class: "font-medium" }
const _hoisted_204 = { class: "flex justify-between items-center mb-2" }
const _hoisted_205 = { class: "font-medium" }
const _hoisted_206 = { class: "flex justify-between items-center" }
const _hoisted_207 = { class: "text-xl font-bold text-red-500" }
const _hoisted_208 = { class: "space-y-4" }
const _hoisted_209 = ["value"]
const _hoisted_210 = {
  key: 7,
  class: "fixed inset-0 bg-black z-50 flex flex-col"
}
const _hoisted_211 = { class: "flex-1 relative overflow-hidden w-full h-full" }
const _hoisted_212 = {
  key: 0,
  class: "absolute inset-0 pointer-events-none z-20"
}
const _hoisted_213 = {
  key: 0,
  class: "bg-black bg-opacity-80 px-4 py-3"
}
const _hoisted_214 = { class: "text-sm font-medium" }
const _hoisted_215 = {
  key: 8,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
}
const _hoisted_216 = { class: "bg-white rounded-xl p-6 w-96 max-w-md" }
const _hoisted_217 = { class: "mb-6" }
const _hoisted_218 = {
  key: 0,
  class: "text-red-500 text-sm mt-2"
}
const _hoisted_219 = { class: "flex space-x-3" }
const _hoisted_220 = ["disabled"]
const _hoisted_221 = { key: 0 }
const _hoisted_222 = { key: 1 }
const _hoisted_223 = {
  key: 0,
  class: "refund-modal-body p-6 overflow-y-auto flex-1 min-h-0"
}
const _hoisted_224 = { class: "mb-4 p-3 bg-gray-50 rounded-lg" }
const _hoisted_225 = { class: "flex justify-between items-center mb-2" }
const _hoisted_226 = { class: "font-medium" }
const _hoisted_227 = { class: "flex justify-between items-center mb-2" }
const _hoisted_228 = { class: "font-medium" }
const _hoisted_229 = { class: "flex justify-between items-center" }
const _hoisted_230 = { class: "font-medium" }
const _hoisted_231 = { class: "mb-4" }
const _hoisted_232 = { class: "flex gap-6" }
const _hoisted_233 = { class: "flex items-center cursor-pointer" }
const _hoisted_234 = { class: "flex items-center cursor-pointer" }
const _hoisted_235 = { class: "mb-4" }
const _hoisted_236 = {
  key: 0,
  class: "py-8 text-center text-gray-500"
}
const _hoisted_237 = {
  key: 1,
  class: "refund-food-scroll overflow-x-auto border border-gray-200 rounded-lg"
}
const _hoisted_238 = { class: "w-full min-w-[760px] text-sm" }
const _hoisted_239 = { class: "divide-y divide-gray-200" }
const _hoisted_240 = { class: "p-3 text-center" }
const _hoisted_241 = ["onUpdate:modelValue", "disabled"]
const _hoisted_242 = { class: "p-3 text-left" }
const _hoisted_243 = { class: "font-medium" }
const _hoisted_244 = { class: "text-xs text-gray-500" }
const _hoisted_245 = { class: "p-3 text-center" }
const _hoisted_246 = { class: "p-3 text-center" }
const _hoisted_247 = { class: "p-3 text-center" }
const _hoisted_248 = { class: "p-3 text-center" }
const _hoisted_249 = ["onUpdate:modelValue", "max", "disabled"]
const _hoisted_250 = { class: "p-3 text-right" }
const _hoisted_251 = { class: "p-3 text-right font-medium text-yellow-600" }
const _hoisted_252 = { key: 0 }
const _hoisted_253 = { class: "mb-4 flex justify-between items-center rounded-lg bg-yellow-50 p-3" }
const _hoisted_254 = { class: "text-xl font-semibold text-yellow-600" }
const _hoisted_255 = { class: "mb-4" }
const _hoisted_256 = {
  key: 1,
  class: "flex gap-3 border-t bg-white px-6 py-4 shrink-0"
}
const _hoisted_257 = ["disabled"]
const _hoisted_258 = { key: 0 }
const _hoisted_259 = { key: 1 }

import { ref, computed, onMounted, nextTick } from 'vue';
  import { useRouter } from 'vue-router';
  import { restoreSelectedShop } from '@/utils/selectedShop';
  import { fetchShopList } from '@/service/base';
  import {
    getOrderList,
    getOrder,
    insertOrderPayment,
    insertOrderInvoice,
    cancelOrder,
    orderPrint,
    orderSlipPrint,
    bookOrderSlipPrint,
    deliveryOrderSlipPrint,
    orderFoodPrint,
    insertOrderRefund,
    orderRefundComplete,
  } from '@/service/order';
  import type { FoodList, OrderDetailModel, OrderListItemModel, PaymentList } from '@/model/order';
  import { OrderPaymentModel } from '@/model/orderPayment';
  import { dateTimeFormat } from '@/utils/utils';
  import dayjs from 'dayjs';
  import { showDialog } from 'vant';
  import { scanPayment, refreshScanPayment } from '@/service/payment';
  import { Html5Qrcode } from 'html5-qrcode';
  import { useCurrentEmployee } from '@/composables/useCurrentEmployee';
  import OrderInvoiceDetails from '@/components/OrderInvoiceDetails.vue';

  interface InvoiceForm {
    type: 'personal' | 'company';
    companyName: string;
    taxNumber: string;
    emailAddress: string;
  }

  interface RefundDetailItem {
    orderRefundId?: number;
    refundNo?: string;
    refundMethodName?: string;
    amount?: number;
    refundStatus?: number;
    refundTime?: string | Date | null;
    refundReason?: string;
    foodList?: Array<{
      orderFoodId?: number;
      quantity?: number;
    }>;
  }

  interface OrderDetailExtra {
    refundList?: RefundDetailItem[];
    isRefund?: number;
    refundAmount?: number;
    refundStatus?: number;
    pickCode?: string;
  }

  interface RefundFoodSelection {
    orderFoodId: number;
    line: number;
    foodName: string;
    foodSpecName: string;
    originalQuantity: number;
    refundedQuantity: number;
    remainingQuantity: number;
    selectedQuantity: number;
    price: number;
    refundableAmount: number;
    selected: boolean;
    disabled: boolean;
  }

  // 响应式数据
  const pageSize = 50;
  const SELECTED_SHOP_KEY = 'table_manage_selected_shop';

  // 保存选中的餐厅到 localStorage（如果后续需要在本页内变更）
  
export default /*@__PURE__*/_defineComponent({
  __name: 'OrderHistoryView',
  setup(__props) {

  const router = useRouter();
  const { employeeName } = useCurrentEmployee();

  const visibleFoodSpec = (dish: FoodList): string => {
    const spec = dish.foodSpecName?.trim();
    return spec && spec !== '标准' ? spec : '';
  };

  const foodDisplayName = (dish: FoodList): string => {
    const name = dish.foodName || dish.shopFoodName || '';
    const spec = visibleFoodSpec(dish);
    return `${name}${spec ? `（${spec}）` : ''}`;
  };

  const formatFoodSummary = (dish: FoodList): string => {
    const cookDesc = dish.foodCookDesc?.trim();
    return `${foodDisplayName(dish)}×${dish.quantity}${cookDesc ? `（${cookDesc}）` : ''}`;
  };

  // 接口定义
  const taxNumberPattern = /^[A-Z0-9]{15,30}$/;
  const emailAddressPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const loading = ref(false);
  const shopList = ref<any[]>([]);
  const tableList = ref<any[]>([]);
  const orderList = ref<OrderListItemModel[]>([]);
  const currentPage = ref(1);
  const totalRecords = ref(0);
  const showOrderDetail = ref(false);
  const showInvoiceModal = ref(false);
  const cancelOrderModalVisible = ref(false);
  const currentCancelOrder = ref<OrderListItemModel | null>(null);
  const cancelRemark = ref('');
  const isCancellingOrder = ref(false);
  const cancelReasonOptions = ['用户取消', '重复下单'];
  // 详情数据兼容详情接口里的扩展字段，如 refundList / pickCode
  const currentOrderDetail = ref<(OrderDetailModel & OrderDetailExtra) | null>(null);

  // 支付相关状态（与新建订单页对齐）
  const paymentConfirmModalVisible = ref(false);
  const selectedPaymentMethod = ref(4); // 默认POS支付
  const paymentRemark = ref('');
  const currentPaymentOrder = ref<OrderListItemModel | null>(null);
  const currentOrderId = ref<number | null>(null);
  const currentOrderNo = ref('');

  const detailTab = ref<'food' | 'coupon' | 'payment' | 'refund' | 'invoice'>('food');

  const currentOrderCoupons = computed(() => {
    const foodList = Array.isArray(currentOrderDetail.value?.foodList)
      ? (currentOrderDetail.value?.foodList as FoodList[])
      : [];

    return foodList.flatMap((dish) => {
      const couponList = Array.isArray(dish.couponList) ? dish.couponList : [];
      return couponList.map((coupon) => ({
        ...coupon,
        sourceFoodName: dish.foodName || dish.shopFoodName || '-',
        sourceFoodSpecName: dish.foodSpecName || '标准',
      }));
    });
  });

  // 扫码支付相关状态
  const scanPaymentModalVisible = ref(false);
  const isScanning = ref(false);
  const scanPaymentRemark = ref('');
  const scanStatus = ref('');
  const scanStatusClass = ref('');
  const scanPaymentFailModalVisible = ref(false);
  const scanPaymentFailErrorMsg = ref('');
  const isRefreshingPayment = ref(false);
  const refreshingPaymentRecordKey = ref<string | null>(null);
  let html5QrCode: Html5Qrcode | null = null;

  // 退款相关状态
  const showRefundModal = ref(false);
  const currentRefundOrder = ref<OrderListItemModel | null>(null);
  const isSubmittingRefund = ref(false);
  const completingRefundOrderIds = ref<number[]>([]);
  const isLoadingRefundDetail = ref(false);
  const refundFoodSelections = ref<RefundFoodSelection[]>([]);
  const refundForm = ref({
    refundType: 1,
    refundReason: '',
  });

  const roundMoney = (value: number) => Math.round((value + Number.EPSILON) * 100) / 100;

  const getSelectedRefundAmount = (item: RefundFoodSelection) => {
    if (!item.selected || item.selectedQuantity <= 0 || item.remainingQuantity <= 0) return 0;
    if (item.selectedQuantity >= item.remainingQuantity) return item.refundableAmount;
    return roundMoney((item.refundableAmount / item.remainingQuantity) * item.selectedQuantity);
  };

  const selectedRefundAmount = computed(() =>
    roundMoney(
      refundFoodSelections.value.reduce((total, item) => total + getSelectedRefundAmount(item), 0),
    ),
  );

  const filters = ref({
    startDate: '',
    endDate: '',
    table: '',
    restaurant: '',
    status: '',
    paymentStatus: '',
    refundStatus: '',
    printOrder: '',
    printOrderSlip: '',
    orderNo: '',
  });

  // 与桌位管理 / 厨房出餐统一使用的本地存储 key
  const saveSelectedShop = (shopId: number | string) => {
    try {
      localStorage.setItem(SELECTED_SHOP_KEY, String(shopId));
    } catch (e) {
      console.warn('保存选中餐厅失败:', e);
    }
  };

  const invoiceForm = ref<InvoiceForm>({
    type: 'personal',
    companyName: '',
    taxNumber: '',
    emailAddress: '',
  });

  // 当前支付订单应付金额（优先剩余金额）
  const currentPayAmount = computed(() => {
    if (!currentPaymentOrder.value) return 0;
    if (currentPaymentOrder.value.remainAmount && currentPaymentOrder.value.remainAmount > 0) {
      return currentPaymentOrder.value.remainAmount;
    }
    return currentPaymentOrder.value.totalAmount || 0;
  });

  // 当前订单菜品总份数
  const currentFoodCount = computed(() => {
    if (!currentPaymentOrder.value || !currentPaymentOrder.value.foodList) return 0;
    return currentPaymentOrder.value.foodList.reduce(
      (sum, dish: any) => sum + (dish.quantity || 0),
      0,
    );
  });

  // 当前订单是否支持线上支付
  const isOnlinePaymentCurrent = computed(() => {
    return !!(currentPaymentOrder.value && isOnlinePayment(currentPaymentOrder.value));
  });

  // 支付方式列表（与新建订单保持一致）
  const paymentMethods = computed(() => {
    const methods = [
      { value: 4, name: 'POS支付' },
      { value: 5, name: '公司挂账' },
      { value: 7, name: '现金支付' },
    ];
    if (isOnlinePaymentCurrent.value) {
      methods.unshift({ value: 3, name: 'B扫C收款' });
    }
    return methods;
  });

  // 从登录态获取员工姓名
  const getEmployeeName = () => {
    return employeeName.value;
  };

  // 计算属性 - 可用桌位列表（根据选择的餐厅筛选）
  const availableTables = computed(() => {
    if (!filters.value.restaurant) {
      return [];
    }
    return tableList.value.filter((table) => table.shopId === Number(filters.value.restaurant));
  });

  const totalFoodCount = computed(() => {
    return orderList.value.reduce((total, order) => {
      const foodCount = Array.isArray(order.foodList)
        ? order.foodList.reduce((sum, dish) => sum + (dish.quantity || 0), 0)
        : 0;
      return total + foodCount;
    }, 0);
  });

  const totalPages = computed(() => Math.max(1, Math.ceil(totalRecords.value / pageSize)));

  const visiblePages = computed(() => {
    const startPage = Math.max(1, Math.min(currentPage.value - 2, totalPages.value - 4));
    const endPage = Math.min(totalPages.value, startPage + 4);
    return Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);
  });

  // 加载餐厅列表
  const loadShopList = async () => {
    try {
      const response = await fetchShopList({
        pageNum: 1,
        pageSize: 100,
        data: { shopStatus: 0 },
      });
      if (response.code === 200) {
        shopList.value = response.result.list;

        const shopId = restoreSelectedShop(shopList.value);
        filters.value.restaurant = shopId ? String(shopId) : '';
        if (shopId) await loadTableList(shopId);
      }
    } catch (error) {
      console.error('加载餐厅列表失败:', error);
      showToast('加载餐厅列表失败');
    }
  };

  // 加载桌位列表 - 使用真实的桌位接口
  const loadTableList = async (shopId?: number) => {
    if (!shopId) {
      tableList.value = [];
      return;
    }
    try {
      // 调用真实的桌位接口
      const params: any = {
        pageNum: 1,
        pageSize: 999,
        data: {},
      };

      if (shopId) {
        params.data.shopId = shopId;
      }

      // 使用post方法直接调用桌位接口
      const { post } = await import('@/utils/api');
      const response = await post<any>('/dim/table/select', params);

      if (response.code === 200) {
        tableList.value = response.result.list || [];
      } else {
        // 如果接口失败，使用模拟数据作为备选
        const mockTables = [
          { tableId: 1, tableName: '1号桌', shopId: 1 },
          { tableId: 2, tableName: '2号桌', shopId: 1 },
          { tableId: 3, tableName: '3号桌', shopId: 1 },
          { tableId: 4, tableName: '4号桌', shopId: 2 },
          { tableId: 5, tableName: '5号桌', shopId: 2 },
          { tableId: 6, tableName: '6号桌', shopId: 2 },
          { tableId: 7, tableName: '7号桌', shopId: 3 },
          { tableId: 8, tableName: '8号桌', shopId: 3 },
          { tableId: 9, tableName: '9号桌', shopId: 4 },
          { tableId: 10, tableName: '10号桌', shopId: 4 },
          { tableId: 11, tableName: '11号桌', shopId: 5 },
          { tableId: 12, tableName: '12号桌', shopId: 5 },
        ];

        if (shopId) {
          tableList.value = mockTables.filter((table) => table.shopId === shopId);
        } else {
          tableList.value = mockTables;
        }
      }
    } catch (error) {
      console.error('加载桌位列表失败:', error);
      showToast('加载桌位列表失败');

      // 出错时使用模拟数据
      const mockTables = [
        { tableId: 1, tableName: '1号桌', shopId: 1 },
        { tableId: 2, tableName: '2号桌', shopId: 1 },
        { tableId: 3, tableName: '3号桌', shopId: 1 },
        { tableId: 4, tableName: '4号桌', shopId: 2 },
        { tableId: 5, tableName: '5号桌', shopId: 2 },
        { tableId: 6, tableName: '6号桌', shopId: 2 },
        { tableId: 7, tableName: '7号桌', shopId: 3 },
        { tableId: 8, tableName: '8号桌', shopId: 3 },
        { tableId: 9, tableName: '9号桌', shopId: 4 },
        { tableId: 10, tableName: '10号桌', shopId: 4 },
        { tableId: 11, tableName: '11号桌', shopId: 5 },
        { tableId: 12, tableName: '12号桌', shopId: 5 },
      ];

      if (shopId) {
        tableList.value = mockTables.filter((table) => table.shopId === shopId);
      } else {
        tableList.value = mockTables;
      }
    }
  };

  // 加载订单列表
  const loadOrderList = async () => {
    if (!filters.value.restaurant) {
      orderList.value = [];
      totalRecords.value = 0;
      showToast('请选择餐厅');
      return;
    }
    try {
      loading.value = true;

      const params: any = {
        pageNum: currentPage.value,
        pageSize,
        data: {},
      };

      // 构建筛选条件
      if (filters.value.restaurant) {
        params.data.shopId = Number(filters.value.restaurant);
      }
      if (filters.value.table) {
        params.data.tableId = Number(filters.value.table);
      }
      if (filters.value.status) {
        params.data.orderStatuss = [Number(filters.value.status)];
      }
      if (filters.value.paymentStatus) {
        params.data.paymentStatuss = [Number(filters.value.paymentStatus)];
      }
      if (filters.value.refundStatus) {
        params.data.refundStatus = Number(filters.value.refundStatus);
      }
      if (filters.value.printOrder !== '') {
        params.data.printOrder = Number(filters.value.printOrder);
      }
      if (filters.value.printOrderSlip !== '') {
        params.data.printOrderSlip = Number(filters.value.printOrderSlip);
      }
      if (filters.value.orderNo && String(filters.value.orderNo).trim()) {
        params.data.orderNo = String(filters.value.orderNo).trim();
      }
      if (filters.value.startDate && filters.value.endDate) {
        // 设置时间范围
        const startDate = new Date(filters.value.startDate);
        const endDate = new Date(filters.value.endDate);

        // 开始日期设置为 00:00:00.000
        startDate.setHours(0, 0, 0, 0);
        // 结束日期设置为 23:59:59.999
        endDate.setHours(23, 59, 59, 999);

        // 格式化为 "YYYY-MM-DD HH:mm:ss" 格式
        const formatDateTime = (date: Date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        params.createtimeBegin = formatDateTime(startDate);
        params.createtimeEnd = formatDateTime(endDate);
      } else if (filters.value.startDate) {
        // 只有开始日期，设置为当天
        const startDate = new Date(filters.value.startDate);
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date(filters.value.startDate);
        endDate.setHours(23, 59, 59, 999);

        const formatDateTime = (date: Date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        params.createtimeBegin = formatDateTime(startDate);
        params.createtimeEnd = formatDateTime(endDate);
      }

      const response = await getOrderList(params);
      if (response.code === 200) {
        orderList.value = response.result.list || [];
        totalRecords.value = response.result.total || 0;
      } else {
        showToast(response.msg || '加载订单列表失败');
      }
    } catch (error) {
      console.error('加载订单列表失败:', error);
      showToast('加载订单列表失败');
    } finally {
      loading.value = false;
    }
  };

  const refreshOrderListPreservingScroll = async () => {
    const scrollPosition = window.scrollY;
    await loadOrderList();
    await nextTick();
    await new Promise<void>((resolve) => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          window.scrollTo({ top: scrollPosition, behavior: 'auto' });
          resolve();
        });
      });
    });
  };

  // 餐厅选择变化事件
  const onRestaurantChange = () => {
    // 清空桌号选择
    filters.value.table = '';
    // 如果选择了具体餐厅，加载该餐厅的桌位列表
    if (filters.value.restaurant) {
      // 保存到本地存储，便于其他页面复用
      saveSelectedShop(filters.value.restaurant);
      loadTableList(Number(filters.value.restaurant));
    }
  };

  // 计算属性
  const getStatusColor = (status?: number) => {
    const colors = {
      1: 'bg-yellow-100 text-yellow-800', // 待确认
      2: 'bg-blue-100 text-blue-800', // 待出餐
      8: 'bg-green-100 text-green-800', // 已出餐
      10: 'bg-red-100 text-red-800', // 已完成
      999: 'bg-purple-100 text-purple-800', // 已取消
    };
    return colors[status as keyof typeof colors] || 'bg-gray-100 text-gray-800';
  };

  const getPaymentStatusColor = (paymentStatusName?: string) => {
    if (!paymentStatusName) return 'bg-gray-100 text-gray-800';

    const statusLower = paymentStatusName.toLowerCase();
    if (statusLower.includes('已支付') || statusLower.includes('支付成功')) {
      return 'bg-green-500 text-white'; // 深绿色背景，白色文字
    } else if (statusLower.includes('未支付') || statusLower.includes('待支付')) {
      return 'bg-red-500 text-white'; // 深红色背景，白色文字
    } else if (statusLower.includes('支付中') || statusLower.includes('处理中')) {
      return 'bg-yellow-500 text-white'; // 黄色背景，白色文字
    } else if (statusLower.includes('退款') || statusLower.includes('已退款')) {
      return 'bg-purple-500 text-white'; // 深紫色背景，白色文字
    }
    return 'bg-gray-500 text-white'; // 默认灰色背景，白色文字
  };

  const getStatusText = (status?: number) => {
    const statusMap = {
      1: '已点餐',
      2: '待出餐',
      8: '已出餐',
      10: '已完成',
      999: '已取消',
    };
    return statusMap[status as keyof typeof statusMap] || '未知状态';
  };

  const getDineTypeText = (dineType?: number) => {
    const dineTypeMap = {
      1: '堂食',
      2: '自提',
      3: '外卖',
      4: '打包',
      5: '预定',
    };
    return dineTypeMap[dineType as keyof typeof dineTypeMap] || '';
  };

  const getDineTypeColor = (dineType?: number) => {
    const colors = {
      1: 'bg-emerald-100 text-emerald-700',
      2: 'bg-amber-100 text-amber-700',
      3: 'bg-cyan-100 text-cyan-700',
      4: 'bg-gray-100 text-gray-700',
      5: 'bg-purple-100 text-purple-700',
    };
    return colors[dineType as keyof typeof colors] || 'bg-gray-100 text-gray-700';
  };

  const getStatusTextColor = (status?: number) => {
    const colors = {
      1: 'text-yellow-600',
      2: 'text-blue-600',
      8: 'text-green-600',
      10: 'text-red-600',
      999: 'text-purple-600',
    };
    return colors[status as keyof typeof colors] || 'text-gray-600';
  };

  // 新增：获取订单层级退款状态文本（0：待退款，10：已退款）
  const getRefundStatusText = (status?: number) => {
    const statusNum = Number(status);
    if (statusNum === 0) return '待退款';
    if (statusNum === 10) return '已退款';
    return '未知状态';
  };

  // 新增：获取订单层级退款状态文本颜色
  const getRefundStatusTextColor = (status?: number) => {
    if (status === undefined || status === null) return 'text-gray-600';
    const statusNum = Number(status);
    if (statusNum === 0) return 'text-yellow-600'; // 待退款 - 黄色
    if (statusNum === 10) return 'text-green-600'; // 已退款 - 绿色
    return 'text-gray-600';
  };

  // 新增：获取退款明细行的退款状态文本（refundList 内部：0待退款，1退款成功，2退款失败）
  const getRefundDetailStatusText = (status?: number) => {
    const statusNum = Number(status);
    if (statusNum === 0) return '待退款';
    if (statusNum === 1) return '退款成功';
    if (statusNum === 2) return '退款失败';
    return '未知状态';
  };

  // 新增：获取退款明细行的退款状态颜色
  const getRefundDetailStatusTextColor = (status?: number) => {
    if (status === undefined || status === null) return 'text-gray-600';
    const statusNum = Number(status);
    if (statusNum === 0) return 'text-yellow-600'; // 待退款 - 黄色
    if (statusNum === 1) return 'text-green-600'; // 退款成功 - 绿色
    if (statusNum === 2) return 'text-red-600'; // 退款失败 - 红色
    return 'text-gray-600';
  };

  // 方法
  const formatDateTime = (dateTime?: string | Date) => {
    if (!dateTime) return '';
    const date = new Date(dateTime);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
  };

  // 新增：判断是否是自提订单
  const isSelfPickupOrder = (order: OrderListItemModel | OrderDetailModel | null) => {
    if (!order) return false;
    return order.dineType === 2 || Boolean(order.tableTag && order.tableTag.includes('自提'));
  };

  const getDisplayPickCode = (order: OrderListItemModel | OrderDetailModel | null) => {
    if (!order) return '';
    if (isSelfPickupOrder(order)) {
      return order.orderNo?.slice(-4) || '';
    }
    return order.pickCode || '';
  };

  const isDeliveryOrder = (order: OrderListItemModel | OrderDetailModel | null) => {
    if (!order) return false;
    return order.dineType === 3;
  };

  // 新增：格式化自提时间显示
  const formatSelfPickupTime = (order: OrderListItemModel | OrderDetailModel | null) => {
    if (!order) return '';
    const date = order.selfPickDate?.trim() || '';
    const time = order.selfPickTime?.trim() || '';
    if (!date && !time) return '';
    if (date && time) return `${date} ${time}`;
    if (date) return date;
    if (time) return time;
    return '';
  };

  const appointmentTimeText = computed(() => formatSelfPickupTime(currentOrderDetail.value));

  const getPaymentRecordStatusText = (status?: number) => {
    if (status === 1) return '成功';
    if (status === 0) return '待支付';
    if (status === 2) return '失败';
    return status === undefined || status === null ? '-' : String(status);
  };

  const canRefreshFailedScanPayment = (payment: PaymentList): boolean => {
    const isScanPayment =
      payment.paymentMethod === 3 || payment.paymentMethodName?.includes('B扫C') === true;
    return isScanPayment && payment.paymentStatus === 2;
  };

  const getPaymentRecordKey = (payment: PaymentList): string =>
    String(payment.orderPaymentId ?? payment.paymentNo ?? payment.orderId ?? '');

  const refreshFailedScanPayment = async (payment: PaymentList) => {
    const orderId = payment.orderId ?? currentOrderDetail.value?.orderId;
    if (!orderId) {
      showDialog({ message: '订单信息不完整，无法查询支付结果' });
      return;
    }

    const paymentRecordKey = getPaymentRecordKey(payment);
    if (refreshingPaymentRecordKey.value === paymentRecordKey) return;

    try {
      refreshingPaymentRecordKey.value = paymentRecordKey;
      const response = await refreshScanPayment({ orderId });

      if (response.code === 200 && response.result?.success) {
        showDialog({ message: '支付成功！' });
        const detailResponse = await getOrder({ orderId });
        if (detailResponse.code === 200 && detailResponse.result) {
          currentOrderDetail.value = detailResponse.result;
        }
        await refreshOrderListPreservingScroll();
        return;
      }

      const errorMsg =
        response.result?.errorMsg || response.msg || '暂未查询到支付成功，请稍后重试';
      showDialog({ message: errorMsg });
    } catch (error) {
      console.error('重新查询扫码支付结果失败:', error);
      showDialog({ message: '查询支付结果失败，请稍后重试' });
    } finally {
      refreshingPaymentRecordKey.value = null;
    }
  };

  const getCouponStatusText = (status?: number) => {
    if (status === 1) return '未使用';
    if (status === 5) return '分享待领取';
    if (status === 6) return '分享已领取';
    if (status === 10) return '已使用';
    if (status === 999) return '已取消';
    return status === undefined || status === null ? '-' : String(status);
  };

  const getCouponStatusClass = (status?: number) => {
    if (status === 1) return 'text-green-600';
    if (status === 5) return 'text-yellow-600';
    if (status === 6) return 'text-blue-600';
    if (status === 10) return 'text-indigo-600';
    if (status === 999) return 'text-gray-500';
    return 'text-yellow-600';
  };

  const getCouponSourceTypeText = (sourceType?: number) => {
    if (sourceType === 1) return '购买';
    if (sourceType === 2) return '分享领取';
    return sourceType === undefined || sourceType === null ? '-' : String(sourceType);
  };

  const getCouponShareText = (isShare?: number) => {
    if (isShare === 1) return '可分享';
    if (isShare === 0) return '不可分享';
    return '-';
  };

  const getCouponDisabledText = (disabled?: number) => {
    if (disabled === 0) return '正常';
    if (disabled === 1) return '已删除';
    return '-';
  };

  const getCouponDisabledClass = (disabled?: number) => {
    if (disabled === 0) return 'text-green-600';
    if (disabled === 1) return 'text-red-600';
    return 'text-gray-500';
  };

  const applyFilters = () => {
    currentPage.value = 1;
    loadOrderList();
  };

  const clearFilters = () => {
    const { startDate, endDate, restaurant } = filters.value;
    filters.value = {
      startDate,
      endDate,
      table: '',
      restaurant,
      status: '',
      paymentStatus: '',
      refundStatus: '',
      printOrder: '',
      printOrderSlip: '',
      orderNo: '',
    };
    currentPage.value = 1;
    loadOrderList();
  };

  const changePage = async (page: number) => {
    if (page < 1 || page > totalPages.value || page === currentPage.value) return;
    currentPage.value = page;
    await loadOrderList();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const viewOrderDetail = async (order: OrderListItemModel) => {
    if (!order.orderId) {
      showToast('订单信息不完整，无法查看详情');
      return;
    }

    try {
      const response = await getOrder({ orderId: order.orderId });
      if (response.code === 200 && response.result) {
        // 使用详情接口返回的数据，包含 refundList 等字段
        currentOrderDetail.value = response.result;
        // 打开详情时，默认切回菜品明细 Tab
        detailTab.value = 'food';
        showOrderDetail.value = true;
      } else {
        showToast(response.msg || '加载订单详情失败');
      }
    } catch (error) {
      console.error('加载订单详情失败:', error);
      showToast('加载订单详情失败');
    }
  };

  const closeOrderDetail = () => {
    showOrderDetail.value = false;
    currentOrderDetail.value = null;
  };

  const openInvoiceModal = (order: OrderListItemModel) => {
    currentOrderDetail.value = order;
    showInvoiceModal.value = true;
  };

  const closeInvoiceModal = () => {
    showInvoiceModal.value = false;
    // 重置表单
    invoiceForm.value = {
      type: 'personal',
      companyName: '',
      taxNumber: '',
      emailAddress: '',
    };
  };

  const generateInvoice = async () => {
    if (!currentOrderDetail.value) return;

    // 验证发票抬头（个人和企业都必填）
    if (!invoiceForm.value.companyName || invoiceForm.value.companyName.trim() === '') {
      showToast('请填写发票抬头');
      return;
    }

    // 验证企业发票税号
    if (invoiceForm.value.type === 'company') {
      const taxNumber = invoiceForm.value.taxNumber.trim();
      if (!taxNumber) {
        showToast('请填写税号');
        return;
      }
      if (!taxNumberPattern.test(taxNumber)) {
        showToast('税号格式应为15-30位大写英文或数字组合');
        return;
      }
    }

    // 验证接收邮箱
    const emailAddress = invoiceForm.value.emailAddress.trim();
    if (!emailAddress) {
      showToast('请填写接收邮箱地址');
      return;
    }
    if (!emailAddressPattern.test(emailAddress)) {
      showToast('请输入正确的邮箱地址');
      return;
    }

    // 组装开票参数，调用后端开票接口
    try {
      const invoiceAmount = currentOrderDetail.value.totalAmount || 0;
      const payload = {
        shopId: currentOrderDetail.value.shopId,
        invoiceType: invoiceForm.value.type === 'company' ? 2 : 1,
        title: invoiceForm.value.companyName.trim(),
        taxNo: invoiceForm.value.type === 'company' ? invoiceForm.value.taxNumber.trim() : '',
        orderCount: 1,
        orderNos: [currentOrderDetail.value.orderNo],
        invoiceAmount,
        receiveType: 1,
        emailAddress,
      };

      const resp = await insertOrderInvoice(payload);
      if (resp.code === 200) {
        showDialog({
          message: `发票开具成功！\n订单号：${
            currentOrderDetail.value.orderNo
          }\n开票金额：¥${invoiceAmount.toFixed(
            2,
          )}\n发票将发送至：${invoiceForm.value.emailAddress.trim()}`,
        });
        // 关闭模态框并刷新订单列表（以更新 invoiceStatus）
        closeInvoiceModal();
        await refreshOrderListPreservingScroll();
      } else {
        showDialog({ message: resp.msg || '开具发票失败，请稍后重试' });
      }
    } catch (e) {
      console.error('开具发票失败:', e);
      showDialog({ message: '开具发票失败，请稍后重试' });
    }
  };

  const printInvoice = (invoiceData: any) => {
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;

    // 获取当前订单对应的餐厅信息
    const currentShop = shopList.value.find(
      (shop) => shop.shopId === currentOrderDetail.value?.shopId,
    );
    const shopName = currentShop?.shopName || '美食集市';
    const shopAddress = currentShop?.shopAddress || shopName;
    const contactPhone = currentShop?.contactPhone || '400-888-8888';

    printWindow.document.write(`
    <html>
      <head>
        <title>发票</title>
        <style>
          body { font-family: Arial, sans-serif; font-size: 14px; margin: 20px; }
          .invoice-header { text-align: center; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 20px; }
          .invoice-title { font-size: 24px; font-weight: bold; margin-bottom: 10px; }
          .invoice-number { font-size: 16px; color: #666; }
          .invoice-info { margin-bottom: 20px; }
          .invoice-info div { margin-bottom: 8px; }
          .invoice-table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
          .invoice-table th, .invoice-table td { border: 1px solid #000; padding: 8px; text-align: left; }
          .invoice-table th { background-color: #f0f0f0; font-weight: bold; }
          .invoice-footer { text-align: center; margin-top: 30px; font-size: 12px; color: #666; }
          .total-amount { font-size: 18px; font-weight: bold; text-align: center; margin: 20px 0; }
        </style>
      </head>
      <body>
        <div class="invoice-header">
          <div class="invoice-title">发票</div>
          <div class="invoice-number">发票号码: ${invoiceData.invoiceNumber}</div>
        </div>
        
        <div class="invoice-info">
          <div><strong>订单号:</strong> ${invoiceData.orderId}</div>
          <div><strong>发票类型:</strong> ${
            invoiceData.type === 'personal' ? '个人发票' : '企业发票'
          }</div>
          ${
            invoiceData.type === 'company'
              ? `
            <div><strong>企业名称:</strong> ${invoiceData.companyName}</div>
            <div><strong>税号:</strong> ${invoiceData.taxNumber}</div>
          `
              : ''
          }
          <div><strong>开票日期:</strong> ${invoiceData.issueDate}</div>
          <div><strong>发票内容:</strong> ${invoiceData.content}</div>
        </div>
        
        <table class="invoice-table">
          <thead>
            <tr>
              <th>项目</th>
              <th>金额</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>${invoiceData.content}</td>
              <td>¥${invoiceData.amount.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
        
        <div class="total-amount">
          合计金额: ¥${invoiceData.amount.toFixed(2)}
        </div>
        
        <div class="invoice-footer">
          <p>${shopName}</p>
          <p>地址: ${shopAddress} | 电话: ${contactPhone}</p>
          <p>开票时间: ${invoiceData.issueDate}</p>
        </div>
      </body>
    </html>
  `);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  };

  const printOrder = () => {
    if (!currentOrderDetail.value) return;

    const printWindow = window.open('', '_blank');
    if (!printWindow) return;

    const orderTime = new Date(currentOrderDetail.value.createTime || '');

    // 获取当前订单对应的餐厅信息
    const currentShop = shopList.value.find(
      (shop) => shop.shopId === currentOrderDetail.value?.shopId,
    );
    const shopName = currentShop?.shopName || '美食集市';
    const shopAddress = currentShop?.shopAddress || '地址未知';
    const contactPhone = currentShop?.contactPhone || '400-888-8888';

    printWindow.document.write(`
    <html>
      <head>
        <title>订单详情</title>
        <style>
          body { font-family: 'Courier New', monospace; font-size: 14px; margin: 20px; }
          .order-header { text-align: center; border-bottom: 2px dashed #000; padding-bottom: 10px; margin-bottom: 15px; }
          .order-title { font-size: 18px; font-weight: bold; margin-bottom: 5px; }
          .order-item { display: flex; justify-content: space-between; margin-bottom: 8px; }
          .order-footer { border-top: 2px dashed #000; padding-top: 10px; margin-top: 15px; text-align: center; font-size: 12px; }
        </style>
      </head>
      <body>
        <div class="order-header">
          <div class="order-title">${shopName} - 订单详情</div>
          <div>订单号: ${currentOrderDetail.value.orderNo}</div>
        </div>
        
        <div class="order-item">
          <span>餐厅:</span>
          <span>${currentOrderDetail.value.shopName}</span>
        </div>
        <div class="order-item">
          <span>桌号:</span>
          <span>${currentOrderDetail.value.tableName}</span>
        </div>
        <div class="order-item">
          <span>用餐人数:</span>
          <span>${currentOrderDetail.value.personCount}人</span>
        </div>
        <div class="order-item">
          <span>服务员:</span>
          <span>${currentOrderDetail.value.userName || '服务员'}</span>
        </div>
        <div class="order-item">
          <span>下单时间:</span>
          <span>${orderTime.toLocaleString()}</span>
        </div>
        <div class="order-item">
          <span>订单状态:</span>
          <span>${getStatusText(currentOrderDetail.value.orderStatus)}</span>
        </div>
        
        <div style="margin: 15px 0; text-align: center; font-weight: bold;">菜品明细</div>
        
        ${(currentOrderDetail.value.foodList || [])
          .filter((dish) => {
            const status = dish.status ?? dish.foodStatus;
            return status !== 999;
          })
          .map(
            (dish) => `
          <div class="order-item">
            <span>${dish.foodName} x${dish.quantity}</span>
            <span>¥${((dish.price || 0) * (dish.quantity || 0)).toFixed(2)}</span>
          </div>
        `,
          )
          .join('')}
        
        <div class="order-footer">
          <div style="font-size: 16px; font-weight: bold; margin-bottom: 10px;">
            总计: ¥${(currentOrderDetail.value.totalAmount || 0).toFixed(2)}
          </div>
          <div>${shopName}</div>
          <div>地址: ${shopAddress} | 电话: ${contactPhone}</div>
          <div>打印时间: ${new Date().toLocaleString()}</div>
        </div>
      </body>
    </html>
  `);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  };

  const goBack = () => {
    router.back();
  };

  const showToast = (message: string) => {
    const toast = document.createElement('div');
    toast.className =
      'fixed top-20 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-70 text-white px-4 py-2 rounded-lg z-50';
    toast.textContent = message;
    document.body.appendChild(toast);

    setTimeout(() => {
      toast.remove();
    }, 2000);
  };

  // 新增：判断是否为未支付或部分支付订单
  const isUnpaidOrder = (order: OrderListItemModel) => {
    // 调试信息
    console.log('检查订单支付状态:', {
      orderNo: order.orderNo,
      paymentStatusName: order.paymentStatusName,
      orderStatus: order.orderStatus,
      totalAmount: order.totalAmount,
      paymentAmount: order.paymentAmount,
      remainAmount: order.remainAmount,
    });

    // 如果订单已取消或已完成且无待支付金额，不显示支付按钮
    if (order.orderStatus === 999) {
      return false; // 已取消
    }

    // 如果有remainAmount字段且大于0，说明有待支付金额
    if (order.remainAmount && order.remainAmount > 0) {
      return true;
    }

    // 如果没有支付状态信息，根据订单状态判断
    if (!order.paymentStatusName) {
      // 订单状态为已完成(10)时，如果没有待支付金额就不需要支付
      if (order.orderStatus === 10 && (!order.remainAmount || order.remainAmount <= 0)) {
        return false;
      }
      // 其他状态默认可以支付
      return true;
    }

    const statusLower = order.paymentStatusName.toLowerCase();
    // 扩展匹配条件：待支付和部分支付都显示支付按钮
    return (
      statusLower.includes('未支付') ||
      statusLower.includes('待支付') ||
      statusLower.includes('部分支付') ||
      statusLower.includes('partial') ||
      statusLower.includes('unpaid') ||
      statusLower.includes('pending') ||
      statusLower === '未付款' ||
      statusLower === '待付款'
    );
  };

  // 新增：判断是否为在线支付订单
  const isOnlinePayment = (order: OrderListItemModel) => {
    return order.shopPaymentLine === 1; // 1 表示线上支付
  };

  // 打开订单查询支付（与新建订单支付流程一致）
  const openHistoryPayment = (order: OrderListItemModel) => {
    if (!order.orderId) {
      showToast('订单信息不完整，无法支付');
      return;
    }
    currentPaymentOrder.value = order;
    currentOrderId.value = order.orderId;
    currentOrderNo.value = order.orderNo || '';

    // 默认支付方式：若支持B扫C则为3，否则为4
    selectedPaymentMethod.value = isOnlinePayment(order) ? 3 : 4;
    paymentRemark.value = '';
    paymentConfirmModalVisible.value = true;
  };

  const hidePaymentConfirmModal = () => {
    paymentConfirmModalVisible.value = false;
    paymentRemark.value = '';
    selectedPaymentMethod.value = isOnlinePaymentCurrent.value ? 3 : 4;
  };

  // 支付确认（选择支付方式后）
  const handlePaymentConfirm = () => {
    if (!currentPaymentOrder.value || !currentOrderId.value) {
      showDialog({ message: '订单信息不完整，无法确认支付' });
      return;
    }
    if (selectedPaymentMethod.value === 3) {
      // B扫C收款
      paymentConfirmModalVisible.value = false;
      showScanPaymentModal();
    } else {
      // 其他线下支付
      confirmPayment();
    }
  };

  // 线下支付确认（POS / 挂账 / 现金）
  const confirmPayment = async () => {
    try {
      if (!currentPaymentOrder.value || !currentOrderId.value) {
        showDialog({ message: '订单信息不完整，无法确认支付' });
        return;
      }

      const employeeName = getEmployeeName();
      let remark = '';
      let paymentMethodName = '';

      if (selectedPaymentMethod.value === 3) {
        paymentMethodName = 'B扫C收款';
        remark = `服务员${employeeName}确认B扫C收款完成，${paymentRemark.value || ''}`;
      } else if (selectedPaymentMethod.value === 4) {
        paymentMethodName = 'POS支付';
        remark = `服务员${employeeName}确认POS支付完成，${paymentRemark.value || ''}`;
      } else if (selectedPaymentMethod.value === 5) {
        paymentMethodName = '公司挂账';
        remark = `服务员${employeeName}确认挂账，${paymentRemark.value || ''}`;
      } else if (selectedPaymentMethod.value === 7) {
        paymentMethodName = '现金支付';
        remark = `服务员${employeeName}确认现金支付完成，${paymentRemark.value || ''}`;
      }

      const paymentData: OrderPaymentModel = {
        orderId: currentOrderId.value,
        paymentMethod: selectedPaymentMethod.value,
        paymentMethodName,
        paymentStatus: 1,
        amount: currentPayAmount.value,
        paymentTime: dateTimeFormat(dayjs()),
        remark: remark.trim(),
      };

      const response = await insertOrderPayment(paymentData);
      if (response.code === 200) {
        hidePaymentConfirmModal();
        showDialog({
          message: `订单 ${
            currentOrderNo.value
          } ${paymentMethodName}已确认完成！\n总金额：¥${currentPayAmount.value.toFixed(2)}\n共${
            currentFoodCount.value
          }份菜品`,
        });
        await refreshOrderListPreservingScroll();
      } else {
        showDialog({ message: response.msg || '确认支付失败' });
      }
    } catch (error) {
      console.error('确认支付失败:', error);
      showDialog({ message: '确认支付失败，请稍后重试' });
    }
  };

  // 显示扫码支付全屏界面
  const showScanPaymentModal = async () => {
    scanPaymentModalVisible.value = true;
    scanPaymentRemark.value = '';
    scanStatus.value = '';
    isScanning.value = true;
    await nextTick();
    getCamerasInfo();
  };

  // 隐藏扫码支付全屏界面
  const hideScanPaymentModal = () => {
    stopScan();
    scanPaymentModalVisible.value = false;
    scanPaymentRemark.value = '';
    scanStatus.value = '';
  };

  // 获取摄像头信息并初始化
  const getCamerasInfo = () => {
    isScanning.value = true;

    Html5Qrcode.getCameras()
      .then((devices) => {
        if (devices && devices.length) {
          html5QrCode = new Html5Qrcode('qr-reader');
          startScan();
        } else {
          isScanning.value = false;
          scanStatus.value = '未检测到摄像头设备';
          scanStatusClass.value = 'bg-red-100 text-red-700';
        }
      })
      .catch((err) => {
        console.error('获取摄像头失败:', err);
        scanStatus.value = '摄像头无访问权限！';
        scanStatusClass.value = 'bg-red-100 text-red-700';
        isScanning.value = false;
      });
  };

  // 开始扫码
  const startScan = () => {
    if (!html5QrCode) {
      console.error('html5QrCode 未初始化');
      return;
    }

    isScanning.value = true;
    scanStatus.value = '';
    scanStatusClass.value = '';

    html5QrCode
      .start(
        { facingMode: 'environment' },
        {
          fps: 20,
          qrbox(viewfinderWidth: number, viewfinderHeight: number) {
            return {
              width: viewfinderWidth,
              height: viewfinderHeight,
            };
          },
          aspectRatio: undefined,
        },
        (decodedText: string) => {
          handleScanResult(decodedText);
        },
      )
      .catch((err: any) => {
        console.error('扫码失败', err);
        scanStatus.value = '启动摄像头失败，请检查权限设置';
        scanStatusClass.value = 'bg-red-100 text-red-700';
        isScanning.value = false;
      });
  };

  // 停止扫描
  const stopScan = () => {
    if (html5QrCode && html5QrCode.isScanning) {
      html5QrCode
        .stop()
        .then(() => {
          html5QrCode?.clear();
          isScanning.value = false;
        })
        .catch((err: any) => {
          console.error('停止扫描失败:', err);
          isScanning.value = false;
        });
    } else {
      isScanning.value = false;
    }
  };

  // 处理扫码结果
  const handleScanResult = async (scanCode: string) => {
    if (!scanCode || scanCode.trim() === '') return;
    stopScan();
    scanStatus.value = '扫码成功，正在处理支付...';
    scanStatusClass.value = 'bg-blue-100 text-blue-700';
    await submitScanPayment(scanCode);
  };

  // 提交扫码支付
  const submitScanPayment = async (scanCode: string) => {
    try {
      if (!currentOrderId.value || !currentPaymentOrder.value) {
        scanStatus.value = '订单信息不完整，无法支付';
        scanStatusClass.value = 'bg-red-100 text-red-700';
        showDialog({ message: '订单信息不完整，无法支付' });
        return;
      }

      const ip = await getClientIP();

      const paymentData = {
        orderId: currentOrderId.value,
        scanCode,
        remark: scanPaymentRemark.value || '',
        ip: ip || '',
        amount: currentPayAmount.value,
      };

      const response = await scanPayment(paymentData);
      if (response.code === 200) {
        hideScanPaymentModal();
        if (response.result?.success) {
          showDialog({
            message: `扫码支付成功！\n总金额：¥${currentPayAmount.value.toFixed(2)}\n共${
              currentFoodCount.value
            }份菜品`,
          });
          await refreshOrderListPreservingScroll();
        } else {
          scanPaymentFailErrorMsg.value = response.result?.errorMsg || '';
          scanPaymentFailModalVisible.value = true;
        }
      } else {
        const errorMsg = response.msg || '支付失败，请重试';
        scanStatus.value = errorMsg;
        scanStatusClass.value = 'bg-red-100 text-red-700';
        showDialog({ message: errorMsg });
        await nextTick();
        getCamerasInfo();
      }
    } catch (error) {
      console.error('扫码支付失败:', error);
      scanStatus.value = '支付失败，请稍后重试';
      scanStatusClass.value = 'bg-red-100 text-red-700';
      showDialog({ message: '支付失败，请稍后重试' });
      await nextTick();
      getCamerasInfo();
    }
  };

  // 获取客户端IP（占位实现）
  const getClientIP = async (): Promise<string> => {
    return '';
  };

  // 确认已经支付（刷新扫码支付状态）
  const confirmScanPaymentPaid = async () => {
    if (isRefreshingPayment.value) return;

    try {
      if (!currentOrderId.value) {
        showDialog({ message: '订单信息不完整，无法确认支付' });
        return;
      }

      isRefreshingPayment.value = true;
      const response = await refreshScanPayment({ orderId: currentOrderId.value });

      if (response.code === 200) {
        if (response.result?.success) {
          scanPaymentFailModalVisible.value = false;
          scanPaymentFailErrorMsg.value = '';
          showDialog({
            message: `支付成功！\n总金额：¥${currentPayAmount.value.toFixed(2)}\n共${
              currentFoodCount.value
            }份菜品`,
          });
          await refreshOrderListPreservingScroll();
        } else {
          const errorMsg = response.result?.errorMsg || '刷新支付状态失败，请重试';
          scanPaymentFailErrorMsg.value = errorMsg;
          showDialog({ message: errorMsg });
        }
      } else {
        const errorMsg = response.msg || '刷新支付状态失败，请稍后重试';
        scanPaymentFailErrorMsg.value = errorMsg;
        showDialog({ message: errorMsg });
      }
    } catch (error) {
      console.error('刷新支付状态失败:', error);
      const errorMsg = '刷新支付状态失败，请稍后重试';
      scanPaymentFailErrorMsg.value = errorMsg;
      showDialog({ message: errorMsg });
    } finally {
      isRefreshingPayment.value = false;
    }
  };

  // 取消扫码支付失败确认
  const cancelScanPaymentConfirm = () => {
    scanPaymentFailModalVisible.value = false;
    scanPaymentFailErrorMsg.value = '';
    isRefreshingPayment.value = false;
  };

  // 新增：判断是否可以开具发票
  const canGenerateInvoice = (order: OrderListItemModel) => {
    // 如果发票状态为已开票（invoiceStatus = 1），则不允许再次开票
    const invoiceStatus = (order as any).invoiceStatus;
    if (Number(invoiceStatus) === 1) {
      return false;
    }

    // 订单必须是已完成状态
    if (order.orderStatus !== 10) {
      return false;
    }

    // 检查支付状态
    if (order.paymentStatusName) {
      const statusLower = order.paymentStatusName.toLowerCase();
      // 支付状态必须包含"已支付"、"支付成功"等关键词
      return (
        statusLower.includes('已支付') ||
        statusLower.includes('支付成功') ||
        statusLower.includes('paid') ||
        statusLower.includes('success')
      );
    }

    // 如果没有支付状态信息，但订单已完成且没有待支付金额，也可以开票
    if (order.orderStatus === 10 && (!order.remainAmount || order.remainAmount <= 0)) {
      return true;
    }

    return false;
  };

  // 新增：判断是否可以取消订单
  const canCancelOrder = (order: OrderListItemModel) => {
    if (Number(order.orderType) !== 0) {
      return false;
    }

    if (Number(order.isRefund) === 1) {
      return false;
    }

    // 只有未确认的订单（状态为1）才可以取消
    return order.orderStatus === 1 || order.orderStatus === 2;
  };

  // 新增：判断是否可以打印收银小票
  const canPrintReceipt = (order: OrderListItemModel) => {
    // 已取消订单不允许打印收银小票
    if (order.orderStatus === 999) return false;

    // 已支付或已完成状态都可以打印收银小票
    // 检查支付状态
    if (order.paymentStatusName) {
      const statusLower = order.paymentStatusName.toLowerCase();
      // 已支付状态
      if (
        statusLower.includes('已支付') ||
        statusLower.includes('支付成功') ||
        statusLower.includes('paid') ||
        statusLower.includes('success')
      ) {
        return true;
      }
    }
    // 订单已完成状态（状态为10）
    if (order.orderStatus === 10) {
      return true;
    }
    // 如果没有支付状态信息，但订单已完成且没有待支付金额，也可以打印
    if (order.orderStatus === 10 && (!order.remainAmount || order.remainAmount <= 0)) {
      return true;
    }
    return false;
  };

  // 新增：判断是否可以打印出餐标签
  const canPrintPickLabel = (order: OrderListItemModel) => {
    // 已取消订单不允许打印出餐标签
    if (order.orderStatus === 999) {
      return false;
    }

    // 订单已完成时不显示，因为已完成就不需要补打出餐标签
    if (order.orderStatus === 10) {
      return false;
    }

    // 只有已支付并且有展示用取餐码才能打印出餐标签
    const pickCode = getDisplayPickCode(order);
    if (!pickCode || pickCode.trim() === '') {
      return false;
    }

    // 检查支付状态
    if (order.paymentStatusName) {
      const statusLower = order.paymentStatusName.toLowerCase();
      // 必须是已支付状态
      return (
        statusLower.includes('已支付') ||
        statusLower.includes('支付成功') ||
        statusLower.includes('paid') ||
        statusLower.includes('success')
      );
    }

    return false;
  };

  // 新增：打印收银小票
  const printReceipt = async (order: OrderListItemModel) => {
    if (!order.orderId) {
      showToast('订单信息不完整，无法打印');
      return;
    }

    try {
      const response = await orderPrint({ orderId: order.orderId });
      if (response.code === 200) {
        showToast('收银小票打印成功');
      } else {
        showToast(response.msg || '打印失败');
      }
    } catch (error) {
      console.error('打印收银小票失败:', error);
      showToast('打印收银小票失败，请稍后重试');
    }
  };

  // 打印订单小票
  const printOrderSlip = async (order: OrderListItemModel) => {
    if (!order.orderId) {
      showToast('订单信息不完整，无法打印');
      return;
    }

    try {
      const response = await orderSlipPrint({ orderId: order.orderId });
      if (response.code === 200) {
        showToast('订单小票打印成功');
      } else {
        showToast(response.msg || '打印失败');
      }
    } catch (error) {
      console.error('打印订单小票失败:', error);
      showToast('打印订单小票失败，请稍后重试');
    }
  };

  // 打印预定订单小票
  const printBookOrderSlip = async (order: OrderListItemModel) => {
    if (!order.orderId) {
      showToast('订单信息不完整，无法打印');
      return;
    }

    try {
      const response = await bookOrderSlipPrint({ orderId: order.orderId });
      if (response.code === 200) {
        showToast('预定订单小票打印成功');
        await refreshOrderListPreservingScroll();
      } else {
        showToast(response.msg || '打印失败');
      }
    } catch (error) {
      console.error('打印预定订单小票失败:', error);
      showToast('打印预定订单小票失败，请稍后重试');
    }
  };

  // 打印外卖订单小票
  const printDeliveryOrderSlip = async (order: OrderListItemModel) => {
    if (!order.orderId) {
      showToast('订单信息不完整，无法打印');
      return;
    }

    try {
      const response = await deliveryOrderSlipPrint({ orderId: order.orderId });
      if (response.code === 200) {
        showToast('外卖订单小票打印成功');
        await refreshOrderListPreservingScroll();
      } else {
        showToast(response.msg || '打印失败');
      }
    } catch (error) {
      console.error('打印外卖订单小票失败:', error);
      showToast('打印外卖订单小票失败，请稍后重试');
    }
  };

  // 新增：打印出餐标签
  const printPickLabel = async (order: OrderListItemModel) => {
    if (!order.orderId) {
      showToast('订单信息不完整，无法打印');
      return;
    }

    const pickCode = getDisplayPickCode(order);
    if (!pickCode || pickCode.trim() === '') {
      showToast('订单没有取餐码，无法打印出餐标签');
      return;
    }

    try {
      const response = await orderFoodPrint({ orderId: order.orderId });
      if (response.code === 200) {
        showToast('出餐标签打印成功');
      } else {
        showToast(response.msg || '打印失败');
      }
    } catch (error) {
      console.error('打印出餐标签失败:', error);
      showToast('打印出餐标签失败，请稍后重试');
    }
  };

  // 打开取消订单弹层
  const cancelOrderAction = (order: OrderListItemModel) => {
    if (!order.orderId) {
      showToast('订单信息不完整，无法取消');
      return;
    }

    currentCancelOrder.value = order;
    cancelRemark.value = '';
    cancelOrderModalVisible.value = true;
  };

  const closeCancelOrderModal = () => {
    if (isCancellingOrder.value) {
      return;
    }

    cancelOrderModalVisible.value = false;
    currentCancelOrder.value = null;
    cancelRemark.value = '';
  };

  const confirmCancelOrder = async () => {
    const order = currentCancelOrder.value;
    if (!order?.orderId || isCancellingOrder.value) {
      return;
    }

    isCancellingOrder.value = true;
    try {
      const response = await cancelOrder({
        orderId: order.orderId,
        cancelRemark: cancelRemark.value.trim(),
      });
      if (response.code === 200) {
        showToast(`订单 #${order.orderNo} 已取消！`);
        cancelOrderModalVisible.value = false;
        currentCancelOrder.value = null;
        cancelRemark.value = '';
        // 重新加载订单列表以获取最新状态
        await refreshOrderListPreservingScroll();
      } else {
        showToast(response.msg || '取消订单失败');
      }
    } catch (error) {
      console.error('取消订单失败:', error);
      showToast('取消订单失败，请稍后重试');
    } finally {
      isCancellingOrder.value = false;
    }
  };

  // 新增：判断是否可以申请退款
  const canApplyRefund = (order: OrderListItemModel) => {
    if (Number(order.orderType) !== 0) {
      return false;
    }

    // 检查支付状态：paymentStatus > 0（已完成/部分完成）时显示
    const paymentStatus = order.paymentStatus;

    // 如果存在 paymentStatus 字段，直接判断
    if (paymentStatus !== undefined && paymentStatus !== null) {
      if (Number(paymentStatus) <= 0) {
        return false; // 支付状态为0（待支付）或小于0，不能申请退款
      }
    } else {
      // 如果没有 paymentStatus 字段，通过 paymentStatusName 判断
      if (order.paymentStatusName) {
        const statusLower = order.paymentStatusName.toLowerCase();
        // 必须是已支付或部分支付状态
        const isPaidOrPartial =
          statusLower.includes('已支付') ||
          statusLower.includes('支付成功') ||
          statusLower.includes('部分支付') ||
          statusLower.includes('paid') ||
          statusLower.includes('success') ||
          statusLower.includes('partial');
        if (!isPaidOrPartial) {
          return false;
        }
      } else {
        // 如果没有支付状态信息，检查是否有已支付金额
        if (!order.paymentAmount || order.paymentAmount <= 0) {
          return false;
        }
      }
    }

    const remainingRefundable = (order.foodList || []).reduce(
      (total, food) =>
        total +
        Math.max(
          0,
          Number(food.amount || 0) -
            Number(food.orderDiscountAmount || 0) -
            Number(food.refundAmount || 0),
        ),
      0,
    );
    if (remainingRefundable <= 0) {
      return false;
    }

    return true;
  };

  // 新增：判断是否可以完成退款
  const canCompleteRefund = (order: OrderListItemModel) => {
    // 检查退款状态：refundStatus 为 0（待退款）时可以完成退款
    const refundStatus = order.refundStatus;
    // 确保 refundStatus 存在且等于 0（待退款）
    if (refundStatus === undefined || refundStatus === null) {
      return false;
    }
    // 支持数字和字符串类型的比较，refundStatus = 0 时显示完成退款按钮
    return Number(refundStatus) === 0;
  };

  // 新增：打开申请退款对话框
  const buildRefundFoodSelections = (
    foodList: FoodList[],
    refundList: RefundDetailItem[],
  ): RefundFoodSelection[] => {
    const refundedQuantities = new Map<number, number>();
    refundList
      .filter((refund) => Number(refund.refundStatus) !== 2)
      .forEach((refund) => {
        (refund.foodList || []).forEach((food) => {
          if (!food.orderFoodId) return;
          refundedQuantities.set(
            food.orderFoodId,
            (refundedQuantities.get(food.orderFoodId) || 0) + Number(food.quantity || 0),
          );
        });
      });

    return foodList.map((food, index) => {
      const orderFoodId = Number(food.orderFoodId || 0);
      const originalQuantity = Number(food.quantity || 0);
      const refundedQuantity = Math.min(originalQuantity, refundedQuantities.get(orderFoodId) || 0);
      const remainingQuantity = Math.max(0, originalQuantity - refundedQuantity);
      const refundableAmount = roundMoney(
        Math.max(
          0,
          Number(food.amount || 0) -
            Number(food.orderDiscountAmount || 0) -
            Number(food.refundAmount || 0),
        ),
      );
      const disabled =
        !orderFoodId ||
        Number(food.status) === 999 ||
        remainingQuantity <= 0 ||
        refundableAmount <= 0;
      return {
        orderFoodId,
        line: Number(food.line ?? index + 1),
        foodName: food.foodName || food.shopFoodName || '-',
        foodSpecName: food.foodSpecName || '标准',
        originalQuantity,
        refundedQuantity,
        remainingQuantity,
        selectedQuantity: disabled ? 0 : 1,
        price: Number(food.price || 0),
        refundableAmount,
        selected: false,
        disabled,
      };
    });
  };

  const openRefundModal = async (order: OrderListItemModel) => {
    if (!order.orderId) {
      showToast('订单信息不完整，无法申请退款');
      return;
    }
    currentRefundOrder.value = order;
    refundForm.value = {
      refundType: 1,
      refundReason: '',
    };
    refundFoodSelections.value = [];
    showRefundModal.value = true;
    try {
      isLoadingRefundDetail.value = true;
      const response = await getOrder({ orderId: order.orderId });
      if (response.code !== 200 || !response.result) {
        showToast(response.msg || '加载订单菜品失败');
        return;
      }
      const detail = response.result as OrderDetailModel & OrderDetailExtra;
      currentRefundOrder.value = { ...order, ...detail };
      refundFoodSelections.value = buildRefundFoodSelections(
        detail.foodList || [],
        detail.refundList || [],
      );
    } catch (error) {
      console.error('加载退款菜品失败:', error);
      showToast('加载订单菜品失败，请稍后重试');
    } finally {
      isLoadingRefundDetail.value = false;
    }
  };

  // 新增：关闭申请退款对话框
  const closeRefundModal = () => {
    showRefundModal.value = false;
    currentRefundOrder.value = null;
    refundFoodSelections.value = [];
    refundForm.value = {
      refundType: 1,
      refundReason: '',
    };
  };

  // 新增：提交退款申请
  const submitRefund = async () => {
    if (!currentRefundOrder.value || !currentRefundOrder.value.orderId) {
      showToast('订单信息不完整，无法申请退款');
      return;
    }
    if (![1, 2].includes(refundForm.value.refundType)) {
      showToast('请选择退款类型');
      return;
    }

    const selectedFoods = refundFoodSelections.value.filter((item) => item.selected);
    if (selectedFoods.length === 0) {
      showToast('请至少选择一个退款菜品');
      return;
    }
    const hasInvalidQuantity = selectedFoods.some(
      (item) =>
        !Number.isInteger(item.selectedQuantity) ||
        item.selectedQuantity <= 0 ||
        item.selectedQuantity > item.remainingQuantity,
    );
    if (hasInvalidQuantity) {
      showToast('退款数量必须为不超过可退数量的正整数');
      return;
    }
    const amount = selectedRefundAmount.value;
    if (amount <= 0) {
      showToast('所选菜品没有可退款金额');
      return;
    }

    // 验证退款原因
    if (!refundForm.value.refundReason || refundForm.value.refundReason.trim() === '') {
      showToast('请输入退款原因');
      return;
    }

    try {
      isSubmittingRefund.value = true;
      const response = await insertOrderRefund({
        orderId: currentRefundOrder.value.orderId,
        refundType: refundForm.value.refundType,
        refundStatus: 0,
        amount,
        refundTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        refundReason: refundForm.value.refundReason.trim(),
        remark: '',
        isValidateStatus: 1,
        foodList: selectedFoods.map((item) => ({
          orderFoodId: item.orderFoodId,
          line: item.line,
          quantity: item.selectedQuantity,
          price: item.price,
          amount: getSelectedRefundAmount(item),
          remark: '',
        })),
      });

      if (response.code === 200) {
        showDialog({
          message: `退款申请已提交成功！\n订单号：${
            currentRefundOrder.value.orderNo
          }\n退款金额：¥${amount.toFixed(2)}`,
        });
        closeRefundModal();
        // 部分退款在创建时已完成，使用服务端状态决定是否显示“完成退款”。
        await refreshOrderListPreservingScroll();
      } else {
        showDialog({ message: response.msg || '申请退款失败' });
      }
    } catch (error) {
      console.error('申请退款失败:', error);
      showDialog({ message: '申请退款失败，请稍后重试' });
    } finally {
      isSubmittingRefund.value = false;
    }
  };

  // 新增：完成退款操作
  const completeRefundAction = async (order: OrderListItemModel) => {
    if (!order.orderId) {
      showToast('订单信息不完整，无法完成退款');
      return;
    }

    const orderId = order.orderId;
    if (completingRefundOrderIds.value.includes(orderId)) return;

    if (!confirm(`确定要完成订单 #${order.orderNo} 的退款吗？`)) {
      return;
    }

    try {
      completingRefundOrderIds.value.push(orderId);
      const response = await orderRefundComplete({
        orderId,
      });

      if (response.code === 200) {
        showDialog({
          message: `退款已完成！\n订单号：${order.orderNo}`,
        });
        await refreshOrderListPreservingScroll();
      } else {
        showDialog({ message: response.msg || '完成退款失败' });
      }
    } catch (error) {
      console.error('完成退款失败:', error);
      showDialog({ message: '完成退款失败，请稍后重试' });
    } finally {
      completingRefundOrderIds.value = completingRefundOrderIds.value.filter(
        (id) => id !== orderId,
      );
    }
  };

  // 生命周期
  onMounted(async () => {
    // 设置默认日期为今天
    const today = new Date().toISOString().split('T')[0];
    filters.value.startDate = today;
    filters.value.endDate = today;

    // 加载基础数据
    await loadShopList();
    await loadOrderList(); // 加载订单列表
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "bg-blue-500 text-white px-4 py-3 flex items-center justify-between sticky top-0 z-10" }, [
      _createElementVNode("div", { class: "flex items-center" }, [
        _createElementVNode("button", {
          class: "bg-blue-600 hover:bg-blue-700 px-3 py-2 rounded-lg mr-4 transition-colors",
          onClick: goBack
        }, _cache[33] || (_cache[33] = [
          _createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
        ])),
        _cache[34] || (_cache[34] = _createElementVNode("h1", { class: "text-2xl font-semibold" }, "订单查询", -1))
      ]),
      _cache[35] || (_cache[35] = _createElementVNode("div", { class: "flex items-center" }, [
        _createElementVNode("span", { class: "text-sm bg-blue-600 px-3 py-1 rounded-full" }, "服务员系统")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[36] || (_cache[36] = _createElementVNode("label", { class: "text-sm font-medium text-gray-700 mb-1" }, "开始日期", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value.startDate) = $event)),
              type: "date",
              class: "border border-gray-300 rounded-lg px-3 py-2 text-sm"
            }, null, 512), [
              [_vModelText, filters.value.startDate]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[37] || (_cache[37] = _createElementVNode("label", { class: "text-sm font-medium text-gray-700 mb-1" }, "结束日期", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.endDate) = $event)),
              type: "date",
              class: "border border-gray-300 rounded-lg px-3 py-2 text-sm"
            }, null, 512), [
              [_vModelText, filters.value.endDate]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[39] || (_cache[39] = _createElementVNode("label", { class: "text-sm font-medium text-gray-700 mb-1" }, "餐厅筛选", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.restaurant) = $event)),
              disabled: "",
              class: "border border-gray-300 rounded-lg px-3 py-2 text-sm min-w-[120px]",
              onChange: onRestaurantChange
            }, [
              _cache[38] || (_cache[38] = _createElementVNode("option", {
                value: "",
                disabled: ""
              }, "请选择餐厅", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shopList.value, (shop) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: shop.shopId,
                  value: String(shop.shopId)
                }, _toDisplayString(shop.shopName), 9, _hoisted_8))
              }), 128))
            ], 544), [
              [_vModelSelect, filters.value.restaurant]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[41] || (_cache[41] = _createElementVNode("label", { class: "text-sm font-medium text-gray-700 mb-1" }, "桌号筛选", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.table) = $event)),
              disabled: !filters.value.restaurant,
              class: _normalizeClass(["border border-gray-300 rounded-lg px-3 py-2 text-sm min-w-[100px]", { 'bg-gray-100': !filters.value.restaurant }])
            }, [
              _cache[40] || (_cache[40] = _createElementVNode("option", { value: "" }, "全部桌号", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableTables.value, (table) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: table.tableId,
                  value: table.tableId
                }, _toDisplayString(table.tableName), 9, _hoisted_11))
              }), 128))
            ], 10, _hoisted_10), [
              [_vModelSelect, filters.value.table]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[42] || (_cache[42] = _createElementVNode("label", { class: "text-sm font-medium text-gray-700 mb-1" }, "订单号", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.value.orderNo) = $event)),
              type: "text",
              placeholder: "输入订单号",
              class: "border border-gray-300 rounded-lg px-3 py-2 text-sm min-w-[160px]"
            }, null, 512), [
              [_vModelText, filters.value.orderNo]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[44] || (_cache[44] = _createElementVNode("label", { class: "text-sm font-medium text-gray-700 mb-1" }, "订单状态", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.value.status) = $event)),
              class: "border border-gray-300 rounded-lg px-3 py-2 text-sm"
            }, _cache[43] || (_cache[43] = [
              _createStaticVNode("<option value=\"\" data-v-71c0f106>全部状态</option><option value=\"1\" data-v-71c0f106>已点餐</option><option value=\"2\" data-v-71c0f106>待出餐</option><option value=\"8\" data-v-71c0f106>已出餐</option><option value=\"10\" data-v-71c0f106>已完成</option><option value=\"999\" data-v-71c0f106>已取消</option>", 6)
            ]), 512), [
              [_vModelSelect, filters.value.status]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[46] || (_cache[46] = _createElementVNode("label", { class: "text-sm font-medium text-gray-700 mb-1" }, "支付状态", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.value.paymentStatus) = $event)),
              class: "border border-gray-300 rounded-lg px-3 py-2 text-sm"
            }, _cache[45] || (_cache[45] = [
              _createElementVNode("option", { value: "" }, "全部支付状态", -1),
              _createElementVNode("option", { value: "0" }, "待支付", -1),
              _createElementVNode("option", { value: "5" }, "部分支付", -1),
              _createElementVNode("option", { value: "10" }, "已支付", -1)
            ]), 512), [
              [_vModelSelect, filters.value.paymentStatus]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[48] || (_cache[48] = _createElementVNode("label", { class: "text-sm font-medium text-gray-700 mb-1" }, "退款状态", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.value.refundStatus) = $event)),
              class: "border border-gray-300 rounded-lg px-3 py-2 text-sm"
            }, _cache[47] || (_cache[47] = [
              _createElementVNode("option", { value: "" }, "全部退款状态", -1),
              _createElementVNode("option", { value: "0" }, "待退款", -1),
              _createElementVNode("option", { value: "10" }, "已退款", -1)
            ]), 512), [
              [_vModelSelect, filters.value.refundStatus]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[51] || (_cache[51] = _createElementVNode("label", { class: "text-sm font-medium text-gray-700 mb-1" }, "打印状态", -1)),
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filters.value.printOrder) = $event)),
                "aria-label": "收银小票打印状态",
                class: "border border-gray-300 rounded-lg px-2 py-2 text-sm",
                style: {"width":"108px"}
              }, _cache[49] || (_cache[49] = [
                _createElementVNode("option", { value: "" }, "收银小票", -1),
                _createElementVNode("option", { value: "0" }, "未打印", -1),
                _createElementVNode("option", { value: "1" }, "已打印", -1)
              ]), 512), [
                [_vModelSelect, filters.value.printOrder]
              ]),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filters.value.printOrderSlip) = $event)),
                "aria-label": "订单清单打印状态",
                class: "border border-gray-300 rounded-lg px-2 py-2 text-sm",
                style: {"width":"108px"}
              }, _cache[50] || (_cache[50] = [
                _createElementVNode("option", { value: "" }, "订单清单", -1),
                _createElementVNode("option", { value: "0" }, "未打印", -1),
                _createElementVNode("option", { value: "1" }, "已打印", -1)
              ]), 512), [
                [_vModelSelect, filters.value.printOrderSlip]
              ])
            ])
          ]),
          _createElementVNode("div", { class: "flex gap-3 ml-1 pb-[1px]" }, [
            _createElementVNode("button", {
              class: "bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors",
              onClick: applyFilters
            }, _cache[52] || (_cache[52] = [
              _createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1),
              _createTextVNode("筛选 ", -1)
            ])),
            _createElementVNode("button", {
              class: "bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition-colors",
              onClick: clearFilters
            }, _cache[53] || (_cache[53] = [
              _createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1),
              _createTextVNode("清除 ", -1)
            ]))
          ])
        ])
      ])
    ]),
    (loading.value && orderList.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[54] || (_cache[54] = [
          _createElementVNode("i", { class: "fas fa-spinner fa-spin text-4xl text-blue-500 mb-4" }, null, -1),
          _createElementVNode("p", { class: "text-gray-600" }, "正在加载订单数据...", -1)
        ])))
      : (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            (orderList.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("h2", _hoisted_23, "订单查询列表 - 共 " + _toDisplayString(totalRecords.value) + " 条记录，当前页菜品总份数 " + _toDisplayString(totalFoodCount.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderList.value, (order) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: order.orderId,
                        class: "p-6 hover:bg-gray-50 transition-colors"
                      }, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, "订单 #" + _toDisplayString(order.orderNo), 1),
                              (Number(order.orderType) === 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, " POS订单 "))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_30, "【" + _toDisplayString(order.shopName) + "】", 1),
                              _createElementVNode("div", _hoisted_31, [
                                _createTextVNode(_toDisplayString(order.tableName), 1),
                                (order.seatNumber)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode("/" + _toDisplayString(order.seatNumber), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              (getDineTypeText(order.dineType))
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: _normalizeClass(["px-2 py-1 rounded-full text-xs font-medium", getDineTypeColor(order.dineType)])
                                  }, _toDisplayString(getDineTypeText(order.dineType)), 3))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_32, _toDisplayString(order.personCount) + "人用餐", 1),
                              _createElementVNode("span", {
                                class: _normalizeClass(["px-2 py-1 rounded-full text-xs font-medium", getStatusColor(order.orderStatus)])
                              }, _toDisplayString(getStatusText(order.orderStatus)), 3),
                              (order.paymentStatusName)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 2,
                                    class: _normalizeClass(["px-2 py-1 rounded-full text-xs font-medium", getPaymentStatusColor(order.paymentStatusName)])
                                  }, _toDisplayString(order.paymentStatusName), 3))
                                : _createCommentVNode("", true),
                              (order.isRefund === 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, " 有退款 "))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                _cache[55] || (_cache[55] = _createElementVNode("i", { class: "fas fa-clock mr-1" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(formatDateTime(order.createTime)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_36, [
                                _cache[56] || (_cache[56] = _createElementVNode("i", { class: "fas fa-user mr-1" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(order.userName || '服务员'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_37, [
                                _cache[57] || (_cache[57] = _createElementVNode("i", { class: "fas fa-utensils mr-1" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(order.foodList?.length || 0) + "道菜 ", 1)
                              ]),
                              (isSelfPickupOrder(order))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    _cache[58] || (_cache[58] = _createElementVNode("i", { class: "fas fa-shopping-bag mr-1" }, null, -1)),
                                    _createTextVNode(" 自提：" + _toDisplayString(formatSelfPickupTime(order) || '待确认'), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (getDisplayPickCode(order))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                    _cache[59] || (_cache[59] = _createElementVNode("i", { class: "fas fa-qrcode mr-1" }, null, -1)),
                                    _createTextVNode(" 取餐码：" + _toDisplayString(getDisplayPickCode(order)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (isDeliveryOrder(order))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                    _cache[60] || (_cache[60] = _createElementVNode("i", { class: "fas fa-map-marker-alt mr-1" }, null, -1)),
                                    _createTextVNode(" 送货地址：" + _toDisplayString(order.consigneeAddress || '待填写地址'), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createTextVNode(_toDisplayString(order.foodList?.slice(0, 3).map(formatFoodSummary).join('、') ||
                      '暂无菜品信息') + " ", 1),
                              (order.foodList && order.foodList.length > 3)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_42, "..."))
                                : _createCommentVNode("", true)
                            ]),
                            (order.description)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                  _cache[61] || (_cache[61] = _createElementVNode("i", { class: "fas fa-sticky-note mr-1" }, null, -1)),
                                  _createTextVNode("备注：" + _toDisplayString(order.description), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, "¥" + _toDisplayString((order.totalAmount || 0).toFixed(2)), 1),
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("button", {
                                class: "bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-sm transition-colors",
                                onClick: ($event: any) => (viewOrderDetail(order))
                              }, _cache[62] || (_cache[62] = [
                                _createElementVNode("i", { class: "fas fa-eye mr-1" }, null, -1),
                                _createTextVNode("详情 ", -1)
                              ]), 8, _hoisted_47),
                              (isUnpaidOrder(order))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded text-sm transition-colors",
                                    onClick: ($event: any) => (openHistoryPayment(order))
                                  }, _cache[63] || (_cache[63] = [
                                    _createElementVNode("i", { class: "fas fa-credit-card mr-1" }, null, -1),
                                    _createTextVNode("支付 ", -1)
                                  ]), 8, _hoisted_48))
                                : _createCommentVNode("", true),
                              (canGenerateInvoice(order))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-sm transition-colors",
                                    onClick: ($event: any) => (openInvoiceModal(order))
                                  }, _cache[64] || (_cache[64] = [
                                    _createElementVNode("i", { class: "fas fa-file-invoice mr-1" }, null, -1),
                                    _createTextVNode("开票 ", -1)
                                  ]), 8, _hoisted_49))
                                : _createCommentVNode("", true),
                              (canCancelOrder(order))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    class: "bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-sm transition-colors",
                                    onClick: ($event: any) => (cancelOrderAction(order))
                                  }, _cache[65] || (_cache[65] = [
                                    _createElementVNode("i", { class: "fas fa-times mr-1" }, null, -1),
                                    _createTextVNode("取消订单 ", -1)
                                  ]), 8, _hoisted_50))
                                : _createCommentVNode("", true),
                              (
                        canPrintReceipt(order) ||
                        ((order.dineType === 5 || isDeliveryOrder(order)) &&
                          order.orderStatus !== 999)
                      )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                    (canPrintReceipt(order))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "bg-purple-500 hover:bg-purple-600 px-2 py-1 transition-colors",
                                          title: "打印收银小票",
                                          onClick: ($event: any) => (printReceipt(order))
                                        }, [
                                          _cache[66] || (_cache[66] = _createElementVNode("i", { class: "fas fa-receipt mr-1" }, null, -1)),
                                          _createTextVNode("收银 (" + _toDisplayString(order.printOrder ?? '-') + ") ", 1)
                                        ], 8, _hoisted_52))
                                      : _createCommentVNode("", true),
                                    (
                          canPrintReceipt(order) && order.dineType !== 5 && !isDeliveryOrder(order)
                        )
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: "bg-purple-500 hover:bg-purple-600 border-l border-purple-400 px-2 py-1 transition-colors",
                                          title: "打印订单小票",
                                          onClick: ($event: any) => (printOrderSlip(order))
                                        }, " 订单 (" + _toDisplayString(order.printOrderSlip ?? '-') + ") ", 9, _hoisted_53))
                                      : _createCommentVNode("", true),
                                    (order.dineType === 5)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 2,
                                          class: "bg-purple-500 hover:bg-purple-600 border-l border-purple-400 px-2 py-1 transition-colors",
                                          title: "打印预定订单小票",
                                          onClick: ($event: any) => (printBookOrderSlip(order))
                                        }, " 预定 (" + _toDisplayString(order.printBookOrder ?? '-') + ") ", 9, _hoisted_54))
                                      : _createCommentVNode("", true),
                                    (isDeliveryOrder(order))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 3,
                                          class: "bg-purple-500 hover:bg-purple-600 border-l border-purple-400 px-2 py-1 transition-colors",
                                          title: "打印外卖订单小票",
                                          onClick: ($event: any) => (printDeliveryOrderSlip(order))
                                        }, " 外卖 (" + _toDisplayString(order.printDeliveryOrder ?? '-') + ") ", 9, _hoisted_55))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (canPrintPickLabel(order))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 4,
                                    class: "bg-indigo-500 hover:bg-indigo-600 text-white px-3 py-1 rounded text-sm transition-colors",
                                    onClick: ($event: any) => (printPickLabel(order))
                                  }, [
                                    _cache[67] || (_cache[67] = _createElementVNode("i", { class: "fas fa-tag mr-1" }, null, -1)),
                                    _createTextVNode("出餐标签 (" + _toDisplayString(order.printOrderFood ?? '-') + ") ", 1)
                                  ], 8, _hoisted_56))
                                : _createCommentVNode("", true),
                              (canApplyRefund(order))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 5,
                                    class: "bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded text-sm transition-colors",
                                    onClick: ($event: any) => (openRefundModal(order))
                                  }, _cache[68] || (_cache[68] = [
                                    _createElementVNode("i", { class: "fas fa-undo mr-1" }, null, -1),
                                    _createTextVNode("申请退款 ", -1)
                                  ]), 8, _hoisted_57))
                                : _createCommentVNode("", true),
                              (canCompleteRefund(order))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 6,
                                    disabled: 
                        order.orderId !== undefined &&
                        completingRefundOrderIds.value.includes(order.orderId)
                      ,
                                    class: "bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
                                    onClick: ($event: any) => (completeRefundAction(order))
                                  }, _cache[69] || (_cache[69] = [
                                    _createElementVNode("i", { class: "fas fa-check-circle mr-1" }, null, -1),
                                    _createTextVNode("完成退款 ", -1)
                                  ]), 8, _hoisted_58))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]),
                  (totalPages.value > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, " 第 " + _toDisplayString(currentPage.value) + " / " + _toDisplayString(totalPages.value) + " 页，每页 " + _toDisplayString(pageSize) + " 条 ", 1),
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("button", {
                            disabled: currentPage.value === 1,
                            class: "border border-gray-300 rounded px-3 py-1.5 text-sm bg-white transition-colors disabled:cursor-not-allowed disabled:opacity-50",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (changePage(currentPage.value - 1)))
                          }, " 上一页 ", 8, _hoisted_62),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: page,
                              class: _normalizeClass(["min-w-[36px] border rounded px-3 py-1.5 text-sm transition-colors", 
                  page === currentPage.value
                    ? 'border-blue-500 bg-blue-500 text-white'
                    : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-100'
                ]),
                              onClick: ($event: any) => (changePage(page))
                            }, _toDisplayString(page), 11, _hoisted_63))
                          }), 128)),
                          _createElementVNode("button", {
                            disabled: currentPage.value === totalPages.value,
                            class: "border border-gray-300 rounded px-3 py-1.5 text-sm bg-white transition-colors disabled:cursor-not-allowed disabled:opacity-50",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (changePage(currentPage.value + 1)))
                          }, " 下一页 ", 8, _hoisted_64)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ])),
    (!loading.value && orderList.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_65, _cache[70] || (_cache[70] = [
          _createElementVNode("i", { class: "fas fa-receipt text-6xl text-gray-300 mb-4" }, null, -1),
          _createElementVNode("h3", { class: "text-xl font-semibold text-gray-500 mb-2" }, "暂无订单", -1),
          _createElementVNode("p", { class: "text-gray-400" }, "没有符合当前查询条件的订单记录", -1)
        ])))
      : _createCommentVNode("", true),
    (showOrderDetail.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50",
          onClick: closeOrderDetail
        }, [
          _createElementVNode("div", {
            class: "bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-screen overflow-y-auto",
            onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", { class: "bg-blue-500 text-white px-6 py-4 flex items-center justify-between" }, [
              _cache[72] || (_cache[72] = _createElementVNode("h3", { class: "text-xl font-semibold" }, "订单详情", -1)),
              _createElementVNode("button", {
                class: "text-white hover:text-gray-200",
                onClick: closeOrderDetail
              }, _cache[71] || (_cache[71] = [
                _createElementVNode("i", { class: "fas fa-times text-xl" }, null, -1)
              ]))
            ]),
            (currentOrderDetail.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _cache[90] || (_cache[90] = _createElementVNode("h4", { class: "text-lg font-semibold text-gray-800 border-b pb-2" }, "基本信息", -1)),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _cache[73] || (_cache[73] = _createElementVNode("span", { class: "text-gray-600" }, "订单编号：", -1)),
                          _createElementVNode("span", _hoisted_71, _toDisplayString(currentOrderDetail.value.orderNo), 1)
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _cache[74] || (_cache[74] = _createElementVNode("span", { class: "text-gray-600" }, "用户Id：", -1)),
                          _createElementVNode("span", _hoisted_73, _toDisplayString(currentOrderDetail.value.customerId || ''), 1)
                        ]),
                        _createElementVNode("div", _hoisted_74, [
                          _cache[75] || (_cache[75] = _createElementVNode("span", { class: "text-gray-600" }, "餐厅：", -1)),
                          _createElementVNode("span", _hoisted_75, _toDisplayString(currentOrderDetail.value.shopName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          _cache[76] || (_cache[76] = _createElementVNode("span", { class: "text-gray-600" }, "桌号：", -1)),
                          _createElementVNode("span", _hoisted_77, _toDisplayString(currentOrderDetail.value.tableName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_78, [
                          _cache[77] || (_cache[77] = _createElementVNode("span", { class: "text-gray-600" }, "用餐人数：", -1)),
                          _createElementVNode("span", _hoisted_79, _toDisplayString(currentOrderDetail.value.personCount) + "人", 1)
                        ]),
                        _createElementVNode("div", _hoisted_80, [
                          _cache[78] || (_cache[78] = _createElementVNode("span", { class: "text-gray-600" }, "服务员：", -1)),
                          _createElementVNode("span", _hoisted_81, _toDisplayString(currentOrderDetail.value.userName || '服务员'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_82, [
                          _cache[79] || (_cache[79] = _createElementVNode("span", { class: "text-gray-600" }, "订单状态：", -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(["font-medium", getStatusTextColor(currentOrderDetail.value.orderStatus)])
                          }, _toDisplayString(getStatusText(currentOrderDetail.value.orderStatus)), 3)
                        ]),
                        (currentOrderDetail.value.consigneeName)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                              _cache[80] || (_cache[80] = _createElementVNode("span", { class: "text-gray-600 shrink-0" }, "联系人：", -1)),
                              _createElementVNode("span", _hoisted_84, _toDisplayString(currentOrderDetail.value.consigneeName), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (currentOrderDetail.value.consigneePhone)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                              _cache[81] || (_cache[81] = _createElementVNode("span", { class: "text-gray-600 shrink-0" }, "电话：", -1)),
                              _createElementVNode("span", _hoisted_86, _toDisplayString(currentOrderDetail.value.consigneePhone), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (isDeliveryOrder(currentOrderDetail.value))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                              _cache[82] || (_cache[82] = _createElementVNode("span", { class: "text-gray-600 shrink-0" }, "地址：", -1)),
                              _createElementVNode("span", _hoisted_88, _toDisplayString(currentOrderDetail.value.consigneeAddress || '-'), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (getDisplayPickCode(currentOrderDetail.value))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                              _cache[83] || (_cache[83] = _createElementVNode("span", { class: "text-gray-600" }, "取餐码：", -1)),
                              _createElementVNode("span", _hoisted_90, _toDisplayString(getDisplayPickCode(currentOrderDetail.value)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_91, [
                          _cache[84] || (_cache[84] = _createElementVNode("span", { class: "text-gray-600" }, "下单时间：", -1)),
                          _createElementVNode("span", _hoisted_92, _toDisplayString(formatDateTime(currentOrderDetail.value.createTime)), 1)
                        ]),
                        (appointmentTimeText.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                              _cache[85] || (_cache[85] = _createElementVNode("span", { class: "text-gray-600 shrink-0" }, "预约时间：", -1)),
                              _createElementVNode("span", _hoisted_94, _toDisplayString(appointmentTimeText.value), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (currentOrderDetail.value.description)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                              _cache[86] || (_cache[86] = _createElementVNode("span", { class: "text-gray-600" }, "备注：", -1)),
                              _createElementVNode("span", _hoisted_96, _toDisplayString(currentOrderDetail.value.description), 1)
                            ]))
                          : _createCommentVNode("", true),
                        ((currentOrderDetail.value as any).isRefund === 1)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                              _cache[89] || (_cache[89] = _createElementVNode("div", { class: "flex justify-between" }, [
                                _createElementVNode("span", { class: "text-gray-600" }, "是否有退款："),
                                _createElementVNode("span", { class: "font-medium text-green-600" }, "是")
                              ], -1)),
                              _createElementVNode("div", _hoisted_97, [
                                _cache[87] || (_cache[87] = _createElementVNode("span", { class: "text-gray-600" }, "退款金额：", -1)),
                                _createElementVNode("span", _hoisted_98, " ¥" + _toDisplayString(((currentOrderDetail.value as any).refundAmount || 0).toFixed(2)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_99, [
                                _cache[88] || (_cache[88] = _createElementVNode("span", { class: "text-gray-600" }, "退款状态：", -1)),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["font-medium", getRefundStatusTextColor((currentOrderDetail.value as any).refundStatus)])
                                }, _toDisplayString(getRefundStatusText((currentOrderDetail.value as any).refundStatus)), 3)
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_100, [
                      _cache[96] || (_cache[96] = _createElementVNode("h4", { class: "text-lg font-semibold text-gray-800 border-b pb-2" }, "金额统计", -1)),
                      _createElementVNode("div", _hoisted_101, [
                        _createElementVNode("div", _hoisted_102, [
                          _cache[91] || (_cache[91] = _createElementVNode("span", { class: "text-gray-600" }, "菜品总计：", -1)),
                          _createElementVNode("span", _hoisted_103, "¥" + _toDisplayString((currentOrderDetail.value.foodAmount || 0).toFixed(2)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_104, [
                          _cache[92] || (_cache[92] = _createElementVNode("span", { class: "text-gray-600" }, "服务费：", -1)),
                          _createElementVNode("span", _hoisted_105, "¥" + _toDisplayString((currentOrderDetail.value.serviceAmount || 0).toFixed(2)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_106, [
                          _cache[93] || (_cache[93] = _createElementVNode("span", { class: "text-gray-600" }, "打包费：", -1)),
                          _createElementVNode("span", _hoisted_107, "¥" + _toDisplayString((currentOrderDetail.value.packageAmount || 0).toFixed(2)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_108, [
                          _cache[94] || (_cache[94] = _createElementVNode("span", { class: "text-gray-600" }, "折扣金额：", -1)),
                          _createElementVNode("span", _hoisted_109, "-¥" + _toDisplayString((currentOrderDetail.value.discountAmount || 0).toFixed(2)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_110, [
                          _cache[95] || (_cache[95] = _createElementVNode("span", null, "订单总计：", -1)),
                          _createElementVNode("span", _hoisted_111, "¥" + _toDisplayString((currentOrderDetail.value.totalAmount || 0).toFixed(2)), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_112, [
                    _createElementVNode("div", _hoisted_113, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["pb-2 text-sm font-medium border-b-2", 
                  detailTab.value === 'food'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500'
                ]),
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (detailTab.value = 'food'))
                      }, " 菜品明细 ", 2),
                      (currentOrderCoupons.value.length > 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: _normalizeClass(["pb-2 text-sm font-medium border-b-2", 
                  detailTab.value === 'coupon'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500'
                ]),
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (detailTab.value = 'coupon'))
                          }, " 卡券列表 ", 2))
                        : _createCommentVNode("", true),
                      ((currentOrderDetail.value.paymentList || []).length > 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: _normalizeClass(["pb-2 text-sm font-medium border-b-2", 
                  detailTab.value === 'payment'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500'
                ]),
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (detailTab.value = 'payment'))
                          }, " 支付明细 ", 2))
                        : _createCommentVNode("", true),
                      ((currentOrderDetail.value as any).isRefund === 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: _normalizeClass(["pb-2 text-sm font-medium border-b-2", 
                  detailTab.value === 'refund'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500'
                ]),
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (detailTab.value = 'refund'))
                          }, " 退款明细 ", 2))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: _normalizeClass(["pb-2 text-sm font-medium border-b-2", 
                  detailTab.value === 'invoice'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500'
                ]),
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (detailTab.value = 'invoice'))
                      }, " 发票查看 ", 2)
                    ]),
                    (detailTab.value === 'food')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                          _createElementVNode("div", _hoisted_115, [
                            _createElementVNode("table", _hoisted_116, [
                              _cache[97] || (_cache[97] = _createElementVNode("colgroup", null, [
                                _createElementVNode("col"),
                                _createElementVNode("col", { class: "w-32" }),
                                _createElementVNode("col", { class: "w-24" }),
                                _createElementVNode("col", { class: "w-16" }),
                                _createElementVNode("col", { class: "w-[72px]" }),
                                _createElementVNode("col", { class: "w-24" }),
                                _createElementVNode("col", { class: "w-24" })
                              ], -1)),
                              _cache[98] || (_cache[98] = _createElementVNode("thead", { class: "bg-gray-50 whitespace-nowrap" }, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", { class: "text-left p-3 font-medium text-gray-700" }, "菜品名称"),
                                  _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700" }, "单价"),
                                  _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700" }, "折扣金额"),
                                  _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700" }, "数量"),
                                  _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700" }, "类型"),
                                  _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700" }, "菜品状态"),
                                  _createElementVNode("th", { class: "text-right p-3 font-medium text-gray-700" }, "小计")
                                ])
                              ], -1)),
                              _createElementVNode("tbody", _hoisted_117, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentOrderDetail.value.foodList || [], (dish) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: dish.orderFoodId
                                  }, [
                                    _createElementVNode("td", _hoisted_118, [
                                      _createElementVNode("div", null, _toDisplayString(foodDisplayName(dish)), 1),
                                      (dish.foodCookDesc?.trim())
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_119, _toDisplayString(dish.foodCookDesc), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("td", _hoisted_120, [
                                      _createElementVNode("span", null, "¥" + _toDisplayString((Number(dish.price) || 0).toFixed(2)), 1),
                                      (
                            dish.sourcePrice != null &&
                            Number(dish.sourcePrice) !== Number(dish.price || 0)
                          )
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_121, " / ¥" + _toDisplayString((Number(dish.sourcePrice) || 0).toFixed(2)), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("td", _hoisted_122, " ¥" + _toDisplayString((dish.discountAmount ?? 0).toFixed(2)), 1),
                                    _createElementVNode("td", _hoisted_123, _toDisplayString(dish.quantity), 1),
                                    _createElementVNode("td", _hoisted_124, [
                                      (dish.addType === 1)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_125, "正常"))
                                        : (dish.addType === 2)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_126, "加菜"))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_127, "未知"))
                                    ]),
                                    _createElementVNode("td", _hoisted_128, [
                                      (dish.status === 1)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_129, "已点餐"))
                                        : (dish.status === 2)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_130, "待出餐"))
                                          : (dish.status === 8)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_131, "已出餐"))
                                            : (dish.status === 9)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_132, "已上菜"))
                                              : (dish.status === 999)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_133, "已取消"))
                                                : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("td", _hoisted_134, " ¥" + _toDisplayString(((dish.price || 0) * (dish.quantity || 0)).toFixed(2)), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (detailTab.value === 'coupon')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                          (currentOrderCoupons.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                                _createElementVNode("div", _hoisted_137, [
                                  _createElementVNode("table", _hoisted_138, [
                                    _cache[99] || (_cache[99] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", { class: "text-left p-3 font-medium text-gray-700 min-w-[120px] whitespace-nowrap" }, " 券名称 "),
                                        _createElementVNode("th", { class: "text-left p-3 font-medium text-gray-700 min-w-[220px] whitespace-nowrap" }, " 券码 "),
                                        _createElementVNode("th", { class: "text-left p-3 font-medium text-gray-700 min-w-[180px] whitespace-nowrap" }, " 来源菜品 "),
                                        _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700 min-w-[100px]" }, " 来源类型 "),
                                        _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700 min-w-[80px] whitespace-nowrap" }, " 序号 "),
                                        _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700 min-w-[120px] whitespace-nowrap" }, " 状态 "),
                                        _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700 min-w-[100px] whitespace-nowrap" }, " 可分享 "),
                                        _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700 min-w-[90px] whitespace-nowrap" }, " 禁用 "),
                                        _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700 min-w-[180px] whitespace-nowrap" }, " 获取时间 "),
                                        _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700 min-w-[180px]" }, " 使用/取消时间 ")
                                      ])
                                    ], -1)),
                                    _createElementVNode("tbody", _hoisted_139, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentOrderCoupons.value, (coupon) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: coupon.customerCouponId || coupon.couponNumber
                                        }, [
                                          _createElementVNode("td", _hoisted_140, [
                                            _createElementVNode("div", null, _toDisplayString(coupon.couponName || '-'), 1),
                                            (coupon.description)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_141, _toDisplayString(coupon.description), 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("td", _hoisted_142, _toDisplayString(coupon.couponNumber || '-'), 1),
                                          _createElementVNode("td", _hoisted_143, [
                                            _createTextVNode(_toDisplayString(coupon.sourceFoodName) + " ", 1),
                                            _createElementVNode("span", _hoisted_144, " / " + _toDisplayString(coupon.sourceFoodSpecName), 1)
                                          ]),
                                          _createElementVNode("td", _hoisted_145, _toDisplayString(getCouponSourceTypeText(coupon.sourceType)), 1),
                                          _createElementVNode("td", _hoisted_146, _toDisplayString(coupon.couponSeq || '-'), 1),
                                          _createElementVNode("td", _hoisted_147, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["font-medium", getCouponStatusClass(coupon.status)])
                                            }, _toDisplayString(getCouponStatusText(coupon.status)), 3)
                                          ]),
                                          _createElementVNode("td", _hoisted_148, _toDisplayString(getCouponShareText(coupon.isShare)), 1),
                                          _createElementVNode("td", _hoisted_149, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(getCouponDisabledClass(coupon.disabled))
                                            }, _toDisplayString(getCouponDisabledText(coupon.disabled)), 3)
                                          ]),
                                          _createElementVNode("td", _hoisted_150, _toDisplayString(formatDateTime(coupon.acquireTime) || '-'), 1),
                                          _createElementVNode("td", _hoisted_151, _toDisplayString(formatDateTime(coupon.useTime) ||
                            formatDateTime(coupon.cancelTime) ||
                            '-'), 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_152, "暂无卡券"))
                        ]))
                      : _createCommentVNode("", true),
                    (detailTab.value === 'payment')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                          ((currentOrderDetail.value.paymentList || []).length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                                _createElementVNode("table", _hoisted_155, [
                                  _cache[102] || (_cache[102] = _createElementVNode("thead", { class: "bg-gray-100" }, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", { class: "text-left p-3 font-medium text-gray-700" }, "支付单号"),
                                      _createElementVNode("th", { class: "text-left p-3 font-medium text-gray-700" }, "支付方式"),
                                      _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700" }, "支付状态"),
                                      _createElementVNode("th", { class: "text-right p-3 font-medium text-gray-700" }, "金额"),
                                      _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700" }, "支付时间"),
                                      _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700" }, "支付线路"),
                                      _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700" }, "操作")
                                    ])
                                  ], -1)),
                                  _createElementVNode("tbody", _hoisted_156, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentOrderDetail.value.paymentList || [], (pay, payIndex) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: pay.orderPaymentId || pay.paymentNo || payIndex
                                      }, [
                                        _createElementVNode("td", _hoisted_157, _toDisplayString(pay.paymentNo || '-'), 1),
                                        _createElementVNode("td", _hoisted_158, _toDisplayString(pay.paymentMethodName || '-'), 1),
                                        _createElementVNode("td", _hoisted_159, _toDisplayString(getPaymentRecordStatusText(pay.paymentStatus)), 1),
                                        _createElementVNode("td", _hoisted_160, " ¥" + _toDisplayString((pay.amount || 0).toFixed(2)), 1),
                                        _createElementVNode("td", _hoisted_161, _toDisplayString(formatDateTime(pay.paymentTime)), 1),
                                        _createElementVNode("td", _hoisted_162, _toDisplayString(pay.paymentLine === 1 ? '线上' : pay.paymentLine === 0 ? '线下' : '-'), 1),
                                        _createElementVNode("td", _hoisted_163, [
                                          (canRefreshFailedScanPayment(pay))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                disabled: refreshingPaymentRecordKey.value === getPaymentRecordKey(pay),
                                                class: "px-3 py-1.5 rounded-md bg-green-500 text-white text-xs font-medium hover:bg-green-600 disabled:bg-gray-400 disabled:cursor-not-allowed",
                                                onClick: ($event: any) => (refreshFailedScanPayment(pay))
                                              }, [
                                                (refreshingPaymentRecordKey.value === getPaymentRecordKey(pay))
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      _cache[100] || (_cache[100] = _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-1" }, null, -1)),
                                                      _cache[101] || (_cache[101] = _createTextVNode("查询中 ", -1))
                                                    ], 64))
                                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                      _createTextVNode("重新查询支付结果")
                                                    ], 64))
                                              ], 8, _hoisted_164))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_165, "-"))
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_166, " 暂无支付记录 "))
                        ]))
                      : _createCommentVNode("", true),
                    (detailTab.value === 'refund' && (currentOrderDetail.value as any).isRefund === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                          _createElementVNode("div", _hoisted_168, [
                            _createElementVNode("table", _hoisted_169, [
                              _cache[103] || (_cache[103] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", { class: "text-left p-3 font-medium text-gray-700" }, "退款单号"),
                                  _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700" }, "退款方式"),
                                  _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700" }, "退款金额"),
                                  _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700" }, "退款状态"),
                                  _createElementVNode("th", { class: "text-center p-3 font-medium text-gray-700" }, "退款时间"),
                                  _createElementVNode("th", { class: "text-left p-3 font-medium text-gray-700" }, "退款原因")
                                ])
                              ], -1)),
                              _createElementVNode("tbody", _hoisted_170, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((currentOrderDetail.value as any).refundList || [], (item) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: item.orderRefundId
                                  }, [
                                    _createElementVNode("td", _hoisted_171, _toDisplayString(item.refundNo), 1),
                                    _createElementVNode("td", _hoisted_172, _toDisplayString(item.refundMethodName || '—'), 1),
                                    _createElementVNode("td", _hoisted_173, " ¥" + _toDisplayString((item.amount || 0).toFixed(2)), 1),
                                    _createElementVNode("td", _hoisted_174, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["font-medium", getRefundDetailStatusTextColor(item.refundStatus)])
                                      }, _toDisplayString(getRefundDetailStatusText(item.refundStatus)), 3)
                                    ]),
                                    _createElementVNode("td", _hoisted_175, _toDisplayString(item.refundTime || '—'), 1),
                                    _createElementVNode("td", _hoisted_176, _toDisplayString(item.refundReason || '—'), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _withDirectives(_createVNode(OrderInvoiceDetails, {
                    "order-no": currentOrderDetail.value.orderNo,
                    "shop-id": currentOrderDetail.value.shopId,
                    active: detailTab.value === 'invoice'
                  }, null, 8, ["order-no", "shop-id", "active"]), [
                    [_vShow, detailTab.value === 'invoice']
                  ]),
                  _createElementVNode("div", _hoisted_177, [
                    (canGenerateInvoice(currentOrderDetail.value))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg transition-colors",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (openInvoiceModal(currentOrderDetail.value)))
                        }, _cache[104] || (_cache[104] = [
                          _createElementVNode("i", { class: "fas fa-file-invoice mr-2" }, null, -1),
                          _createTextVNode("开具发票 ", -1)
                        ])))
                      : _createCommentVNode("", true),
                    (canPrintReceipt(currentOrderDetail.value))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "bg-purple-500 hover:bg-purple-600 text-white px-4 py-2 rounded-lg transition-colors",
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (printReceipt(currentOrderDetail.value)))
                        }, _cache[105] || (_cache[105] = [
                          _createElementVNode("i", { class: "fas fa-receipt mr-2" }, null, -1),
                          _createTextVNode("收银小票 ", -1)
                        ])))
                      : _createCommentVNode("", true),
                    (canPrintPickLabel(currentOrderDetail.value))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "bg-indigo-500 hover:bg-indigo-600 text-white px-4 py-2 rounded-lg transition-colors",
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (printPickLabel(currentOrderDetail.value)))
                        }, [
                          _cache[106] || (_cache[106] = _createElementVNode("i", { class: "fas fa-tag mr-2" }, null, -1)),
                          _createTextVNode("出餐标签 (" + _toDisplayString(currentOrderDetail.value.printOrderFood ?? '-') + ") ", 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition-colors",
                      onClick: closeOrderDetail
                    }, " 关闭 ")
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (showInvoiceModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50",
          onClick: closeInvoiceModal
        }, [
          _createElementVNode("div", {
            class: "bg-white rounded-lg shadow-xl max-w-md w-full",
            onClick: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", { class: "bg-green-500 text-white px-6 py-4 flex items-center justify-between" }, [
              _cache[108] || (_cache[108] = _createElementVNode("h3", { class: "text-xl font-semibold" }, "开具发票", -1)),
              _createElementVNode("button", {
                class: "text-white hover:text-gray-200",
                onClick: closeInvoiceModal
              }, _cache[107] || (_cache[107] = [
                _createElementVNode("i", { class: "fas fa-times text-xl" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_178, [
              _createElementVNode("form", {
                onSubmit: _withModifiers(generateInvoice, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_179, [
                  _cache[110] || (_cache[110] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "发票类型", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((invoiceForm.value.type) = $event)),
                    class: "w-full border border-gray-300 rounded-lg px-3 py-2"
                  }, _cache[109] || (_cache[109] = [
                    _createElementVNode("option", { value: "personal" }, "个人发票", -1),
                    _createElementVNode("option", { value: "company" }, "企业发票", -1)
                  ]), 512), [
                    [_vModelSelect, invoiceForm.value.type]
                  ])
                ]),
                _createElementVNode("div", _hoisted_180, [
                  _cache[111] || (_cache[111] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, [
                    _createTextVNode("发票抬头 "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((invoiceForm.value.companyName) = $event)),
                    type: "text",
                    class: "w-full border border-gray-300 rounded-lg px-3 py-2",
                    placeholder: 
                  invoiceForm.value.type === 'company' ? '请输入单位名称' : '请输入姓名或抬头'
                ,
                    required: ""
                  }, null, 8, _hoisted_181), [
                    [_vModelText, invoiceForm.value.companyName]
                  ])
                ]),
                (invoiceForm.value.type === 'company')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_182, [
                      _cache[112] || (_cache[112] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "税号", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((invoiceForm.value.taxNumber) = $event)),
                        type: "text",
                        class: "w-full border border-gray-300 rounded-lg px-3 py-2",
                        placeholder: "请输入15-30位大写英文或数字",
                        maxlength: "30",
                        required: ""
                      }, null, 512), [
                        [_vModelText, invoiceForm.value.taxNumber]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_183, [
                  _cache[113] || (_cache[113] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, [
                    _createTextVNode("接收邮箱 "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((invoiceForm.value.emailAddress) = $event)),
                    type: "email",
                    class: "w-full border border-gray-300 rounded-lg px-3 py-2",
                    placeholder: "请输入接收发票的邮箱地址",
                    required: ""
                  }, null, 512), [
                    [_vModelText, invoiceForm.value.emailAddress]
                  ])
                ]),
                _createElementVNode("div", { class: "flex gap-3" }, [
                  _cache[114] || (_cache[114] = _createElementVNode("button", {
                    type: "submit",
                    class: "flex-1 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg transition-colors"
                  }, [
                    _createElementVNode("i", { class: "fas fa-file-invoice mr-2" }),
                    _createTextVNode("开具发票 ")
                  ], -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "flex-1 bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition-colors",
                    onClick: closeInvoiceModal
                  }, " 取消 ")
                ])
              ], 32)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (cancelOrderModalVisible.value && currentCancelOrder.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50",
          onClick: _withModifiers(closeCancelOrderModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_184, [
            _createElementVNode("div", _hoisted_185, [
              _cache[116] || (_cache[116] = _createElementVNode("h3", { class: "text-xl font-bold" }, "取消订单", -1)),
              _createElementVNode("button", {
                class: "text-gray-500 hover:text-gray-700",
                disabled: isCancellingOrder.value,
                onClick: closeCancelOrderModal
              }, _cache[115] || (_cache[115] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
              ]), 8, _hoisted_186)
            ]),
            _createElementVNode("p", _hoisted_187, " 确定要取消订单 #" + _toDisplayString(currentCancelOrder.value.orderNo) + " 吗？取消后将无法恢复。 ", 1),
            _createElementVNode("div", _hoisted_188, [
              _cache[117] || (_cache[117] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "选择取消原因（可选）", -1)),
              _createElementVNode("div", _hoisted_189, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cancelReasonOptions, (reason) => {
                  return _createElementVNode("button", {
                    key: reason,
                    type: "button",
                    class: _normalizeClass(["px-4 py-2 rounded-lg border transition-colors", 
                cancelRemark.value === reason
                  ? 'border-red-500 bg-red-50 text-red-600'
                  : 'border-gray-300 text-gray-700 hover:bg-gray-50'
              ]),
                    onClick: ($event: any) => (cancelRemark.value = reason)
                  }, _toDisplayString(reason), 11, _hoisted_190)
                }), 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_191, [
              _cache[118] || (_cache[118] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "取消原因（可选）", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((cancelRemark).value = $event)),
                rows: "3",
                maxlength: "200",
                placeholder: "请输入取消原因，也可以不填直接取消",
                class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 resize-none"
              }, null, 512), [
                [_vModelText, cancelRemark.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_192, [
              _createElementVNode("button", {
                type: "button",
                class: "flex-1 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors",
                disabled: isCancellingOrder.value,
                onClick: closeCancelOrderModal
              }, " 返回 ", 8, _hoisted_193),
              _createElementVNode("button", {
                type: "button",
                class: "flex-1 py-3 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors disabled:bg-gray-400",
                disabled: isCancellingOrder.value,
                onClick: confirmCancelOrder
              }, [
                (isCancellingOrder.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_195, _cache[119] || (_cache[119] = [
                      _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1),
                      _createTextVNode("取消中 ", -1)
                    ])))
                  : (_openBlock(), _createElementBlock("span", _hoisted_196, "确认取消"))
              ], 8, _hoisted_194)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (paymentConfirmModalVisible.value && currentPaymentOrder.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
          _createElementVNode("div", _hoisted_198, [
            _createElementVNode("div", { class: "flex justify-between items-center mb-4" }, [
              _cache[121] || (_cache[121] = _createElementVNode("h3", { class: "text-xl font-bold" }, "选择支付方式", -1)),
              _createElementVNode("button", {
                class: "text-gray-500 hover:text-gray-700",
                onClick: hidePaymentConfirmModal
              }, _cache[120] || (_cache[120] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_199, [
              _createElementVNode("div", _hoisted_200, [
                _cache[122] || (_cache[122] = _createElementVNode("span", { class: "text-gray-600" }, "订单号:", -1)),
                _createElementVNode("span", _hoisted_201, _toDisplayString(currentPaymentOrder.value.orderNo), 1)
              ]),
              _createElementVNode("div", _hoisted_202, [
                _cache[123] || (_cache[123] = _createElementVNode("span", { class: "text-gray-600" }, "餐厅:", -1)),
                _createElementVNode("span", _hoisted_203, _toDisplayString(currentPaymentOrder.value.shopName), 1)
              ]),
              _createElementVNode("div", _hoisted_204, [
                _cache[124] || (_cache[124] = _createElementVNode("span", { class: "text-gray-600" }, "桌号:", -1)),
                _createElementVNode("span", _hoisted_205, _toDisplayString(currentPaymentOrder.value.tableName), 1)
              ]),
              _createElementVNode("div", _hoisted_206, [
                _cache[125] || (_cache[125] = _createElementVNode("span", { class: "text-gray-600" }, "应付金额:", -1)),
                _createElementVNode("span", _hoisted_207, "¥" + _toDisplayString(currentPayAmount.value.toFixed(2)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_208, [
              _createElementVNode("div", null, [
                _cache[126] || (_cache[126] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " 支付方式 ", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((selectedPaymentMethod).value = $event)),
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-lg"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentMethods.value, (method) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: method.value,
                      value: method.value
                    }, _toDisplayString(method.name), 9, _hoisted_209))
                  }), 128))
                ], 512), [
                  [_vModelSelect, selectedPaymentMethod.value]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[127] || (_cache[127] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " 备注信息 ", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((paymentRemark).value = $event)),
                  placeholder: "请输入备注信息（可选）",
                  rows: "3",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-base resize-none"
                }, null, 512), [
                  [_vModelText, paymentRemark.value]
                ])
              ])
            ]),
            _createElementVNode("div", { class: "flex space-x-3 pt-6 mt-6 border-t" }, [
              _createElementVNode("button", {
                class: "flex-1 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium",
                onClick: hidePaymentConfirmModal
              }, " 取消 "),
              _createElementVNode("button", {
                class: "flex-1 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors font-medium",
                onClick: handlePaymentConfirm
              }, " 确认支付 ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (scanPaymentModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
          _createElementVNode("div", { class: "bg-black bg-opacity-80 text-white px-4 py-3 flex items-center justify-between" }, [
            _createElementVNode("button", {
              class: "text-white",
              onClick: hideScanPaymentModal
            }, _cache[128] || (_cache[128] = [
              _createElementVNode("i", { class: "fas fa-times text-2xl" }, null, -1)
            ])),
            _cache[129] || (_cache[129] = _createElementVNode("h3", { class: "text-xl font-bold" }, "B扫C收款", -1)),
            _cache[130] || (_cache[130] = _createElementVNode("div", { class: "w-8" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_211, [
            _cache[132] || (_cache[132] = _createElementVNode("div", {
              id: "qr-reader",
              class: "qr-reader-container w-full h-full"
            }, null, -1)),
            (isScanning.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_212, _cache[131] || (_cache[131] = [
                  _createElementVNode("div", { class: "scan-line" }, null, -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          (scanStatus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_213, [
                _createElementVNode("div", {
                  class: _normalizeClass(["p-3 rounded-lg text-center", scanStatusClass.value])
                }, [
                  _createElementVNode("p", _hoisted_214, _toDisplayString(scanStatus.value), 1)
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (scanPaymentFailModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_215, [
          _createElementVNode("div", _hoisted_216, [
            _createElementVNode("div", { class: "flex justify-between items-center mb-4" }, [
              _cache[134] || (_cache[134] = _createElementVNode("h3", { class: "text-xl font-bold" }, "支付确认", -1)),
              _createElementVNode("button", {
                class: "text-gray-500 hover:text-gray-700",
                onClick: cancelScanPaymentConfirm
              }, _cache[133] || (_cache[133] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_217, [
              _cache[135] || (_cache[135] = _createElementVNode("p", { class: "text-gray-700 text-lg" }, " 扫码支付返回失败，请确认客户是否已经完成支付？ ", -1)),
              (scanPaymentFailErrorMsg.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_218, " 错误信息：" + _toDisplayString(scanPaymentFailErrorMsg.value), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_219, [
              _createElementVNode("button", {
                class: "flex-1 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium",
                onClick: cancelScanPaymentConfirm
              }, " 取消 "),
              _createElementVNode("button", {
                disabled: isRefreshingPayment.value,
                class: _normalizeClass([
              'flex-1 py-3 rounded-lg transition-colors font-medium',
              isRefreshingPayment.value
                ? 'bg-gray-400 text-white cursor-not-allowed'
                : 'bg-green-500 text-white hover:bg-green-600',
            ]),
                onClick: confirmScanPaymentPaid
              }, [
                (isRefreshingPayment.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_221, _cache[136] || (_cache[136] = [
                      _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1),
                      _createTextVNode("确认支付中 ", -1)
                    ])))
                  : (_openBlock(), _createElementBlock("span", _hoisted_222, "确认已经支付"))
              ], 10, _hoisted_220)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showRefundModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 9,
          class: "refund-modal-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50",
          onClick: closeRefundModal
        }, [
          _createElementVNode("div", {
            class: "refund-modal-panel bg-white rounded-lg shadow-xl w-full overflow-hidden flex flex-col",
            onClick: _cache[32] || (_cache[32] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", { class: "bg-yellow-500 text-white px-6 py-4 flex items-center justify-between shrink-0" }, [
              _cache[138] || (_cache[138] = _createElementVNode("h3", { class: "text-xl font-semibold" }, "申请退款", -1)),
              _createElementVNode("button", {
                class: "text-white hover:text-gray-200",
                onClick: closeRefundModal
              }, _cache[137] || (_cache[137] = [
                _createElementVNode("i", { class: "fas fa-times text-xl" }, null, -1)
              ]))
            ]),
            (currentRefundOrder.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_223, [
                  _createElementVNode("div", _hoisted_224, [
                    _createElementVNode("div", _hoisted_225, [
                      _cache[139] || (_cache[139] = _createElementVNode("span", { class: "text-gray-600" }, "订单号:", -1)),
                      _createElementVNode("span", _hoisted_226, _toDisplayString(currentRefundOrder.value.orderNo), 1)
                    ]),
                    _createElementVNode("div", _hoisted_227, [
                      _cache[140] || (_cache[140] = _createElementVNode("span", { class: "text-gray-600" }, "订单金额:", -1)),
                      _createElementVNode("span", _hoisted_228, "¥" + _toDisplayString((currentRefundOrder.value.totalAmount || 0).toFixed(2)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_229, [
                      _cache[141] || (_cache[141] = _createElementVNode("span", { class: "text-gray-600" }, "已支付金额:", -1)),
                      _createElementVNode("span", _hoisted_230, "¥" + _toDisplayString((currentRefundOrder.value.paymentAmount || 0).toFixed(2)), 1)
                    ])
                  ]),
                  _createElementVNode("form", {
                    id: "refund-form",
                    onSubmit: _withModifiers(submitRefund, ["prevent"])
                  }, [
                    _createElementVNode("div", _hoisted_231, [
                      _cache[144] || (_cache[144] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, [
                        _createTextVNode(" 退款类型 "),
                        _createElementVNode("span", { class: "text-red-500" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_232, [
                        _createElementVNode("label", _hoisted_233, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((refundForm.value.refundType) = $event)),
                            type: "radio",
                            value: 1,
                            class: "mr-2"
                          }, null, 512), [
                            [_vModelRadio, refundForm.value.refundType]
                          ]),
                          _cache[142] || (_cache[142] = _createTextVNode(" 退款退货 ", -1))
                        ]),
                        _createElementVNode("label", _hoisted_234, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((refundForm.value.refundType) = $event)),
                            type: "radio",
                            value: 2,
                            class: "mr-2"
                          }, null, 512), [
                            [_vModelRadio, refundForm.value.refundType]
                          ]),
                          _cache[143] || (_cache[143] = _createTextVNode(" 仅退款 ", -1))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_235, [
                      _cache[148] || (_cache[148] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, [
                        _createTextVNode(" 选择退款菜品 "),
                        _createElementVNode("span", { class: "text-red-500" }, "*")
                      ], -1)),
                      (isLoadingRefundDetail.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_236, _cache[145] || (_cache[145] = [
                            _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1),
                            _createTextVNode("正在加载菜品 ", -1)
                          ])))
                        : (_openBlock(), _createElementBlock("div", _hoisted_237, [
                            _createElementVNode("table", _hoisted_238, [
                              _cache[147] || (_cache[147] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", { class: "p-3 text-center" }, "选择"),
                                  _createElementVNode("th", { class: "p-3 text-left" }, "菜品"),
                                  _createElementVNode("th", { class: "p-3 text-center" }, "原数量"),
                                  _createElementVNode("th", { class: "p-3 text-center" }, "已退"),
                                  _createElementVNode("th", { class: "p-3 text-center" }, "可退"),
                                  _createElementVNode("th", { class: "p-3 text-center" }, "退款数量"),
                                  _createElementVNode("th", { class: "p-3 text-right" }, "可退金额"),
                                  _createElementVNode("th", { class: "p-3 text-right" }, "本次退款")
                                ])
                              ], -1)),
                              _createElementVNode("tbody", _hoisted_239, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(refundFoodSelections.value, (item) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: item.orderFoodId,
                                    class: _normalizeClass(item.disabled ? 'bg-gray-50 text-gray-400' : '')
                                  }, [
                                    _createElementVNode("td", _hoisted_240, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event: any) => ((item.selected) = $event),
                                        type: "checkbox",
                                        disabled: item.disabled,
                                        class: "h-4 w-4"
                                      }, null, 8, _hoisted_241), [
                                        [_vModelCheckbox, item.selected]
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_242, [
                                      _createElementVNode("div", _hoisted_243, _toDisplayString(item.foodName), 1),
                                      _createElementVNode("div", _hoisted_244, _toDisplayString(item.foodSpecName), 1)
                                    ]),
                                    _createElementVNode("td", _hoisted_245, _toDisplayString(item.originalQuantity), 1),
                                    _createElementVNode("td", _hoisted_246, _toDisplayString(item.refundedQuantity), 1),
                                    _createElementVNode("td", _hoisted_247, _toDisplayString(item.remainingQuantity), 1),
                                    _createElementVNode("td", _hoisted_248, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event: any) => ((item.selectedQuantity) = $event),
                                        type: "number",
                                        step: "1",
                                        min: "1",
                                        max: item.remainingQuantity,
                                        disabled: item.disabled || !item.selected,
                                        class: "w-20 border border-gray-300 rounded px-2 py-1 text-center disabled:bg-gray-100"
                                      }, null, 8, _hoisted_249), [
                                        [
                                          _vModelText,
                                          item.selectedQuantity,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_250, "¥" + _toDisplayString(item.refundableAmount.toFixed(2)), 1),
                                    _createElementVNode("td", _hoisted_251, " ¥" + _toDisplayString(getSelectedRefundAmount(item).toFixed(2)), 1)
                                  ], 2))
                                }), 128)),
                                (refundFoodSelections.value.length === 0)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_252, _cache[146] || (_cache[146] = [
                                      _createElementVNode("td", {
                                        colspan: "8",
                                        class: "p-6 text-center text-gray-500"
                                      }, "暂无可退款菜品", -1)
                                    ])))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_253, [
                      _cache[149] || (_cache[149] = _createElementVNode("span", { class: "font-medium text-gray-700" }, "本次退款总金额", -1)),
                      _createElementVNode("span", _hoisted_254, " ¥" + _toDisplayString(selectedRefundAmount.value.toFixed(2)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_255, [
                      _cache[150] || (_cache[150] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, [
                        _createTextVNode("退款原因 "),
                        _createElementVNode("span", { class: "text-red-500" }, "*")
                      ], -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((refundForm.value.refundReason) = $event)),
                        rows: "4",
                        class: "refund-reason w-full border border-gray-300 rounded-lg px-3 py-2 resize-none",
                        placeholder: "请输入退款原因",
                        required: ""
                      }, null, 512), [
                        [_vModelText, refundForm.value.refundReason]
                      ])
                    ])
                  ], 32)
                ]))
              : _createCommentVNode("", true),
            (currentRefundOrder.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_256, [
                  _createElementVNode("button", {
                    type: "submit",
                    form: "refund-form",
                    class: "flex-1 bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-lg transition-colors",
                    disabled: isSubmittingRefund.value || isLoadingRefundDetail.value
                  }, [
                    (isSubmittingRefund.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_258, _cache[151] || (_cache[151] = [
                          _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1),
                          _createTextVNode("提交中 ", -1)
                        ])))
                      : (_openBlock(), _createElementBlock("span", _hoisted_259, _cache[152] || (_cache[152] = [
                          _createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1),
                          _createTextVNode("确认申请 ", -1)
                        ])))
                  ], 8, _hoisted_257),
                  _createElementVNode("button", {
                    type: "button",
                    class: "flex-1 bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition-colors",
                    onClick: closeRefundModal
                  }, " 取消 ")
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})